/* eslint no-undef: "off"*/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['exports', 'echarts'], factory);
    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
        // CommonJS
        factory(exports, require('echarts'));
    } else {
        // Browser globals
        factory({}, root.echarts);
    }
}(this, function (exports, echarts) {
    var log = function (msg) {
        if (typeof console !== 'undefined') {
            console && console.error && console.error(msg);
        }
    }
    if (!echarts) {
        log('ECharts is not Loaded');
        return;
    }
    if (!echarts.registerMap) {
        log('ECharts Map is not loaded')
        return;
    }
  echarts.registerMap('台湾',{
  "type": "FeatureCollection",
  "features": [
    {
      "properties": { "COUNTYSN": "10014001", "COUNTYNAME": "台东县", "name": "台东县" },
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [121.60104358069185, 22.017919432960984],
              [121.60104358069185, 22.017919432960984]
            ]
          ],
          [
            [
              [121.60118354868924, 21.953588313711325],
              [121.60118354868924, 21.953588313711325]
            ]
          ],
          [
            [
              [121.61469663511656, 21.95052440290905],
              [121.61469663511656, 21.95052440290905]
            ]
          ],
          [
            [
              [121.60863141154013, 21.944373623937583],
              [121.60863141154013, 21.944373623937583]
            ]
          ],
          [
            [
              [121.41892104726573, 23.224881153093655],
              [121.41892104726573, 23.224881153093655]
            ]
          ],
          [
            [
              [121.41826967968326, 23.224184501106315],
              [121.41826967968326, 23.224184501106315]
            ]
          ],
          [
            [
              [121.417894583956, 23.223818298950796],
              [121.417894583956, 23.223818298950796]
            ]
          ],
          [
            [
              [121.4173982291139, 23.223497578443734],
              [121.4173982291139, 23.223497578443734]
            ]
          ],
          [
            [
              [121.41527073118462, 23.22049623375553],
              [121.41527073118462, 23.22049623375553]
            ]
          ],
          [
            [
              [121.41559183790696, 23.21968400203526],
              [121.41559183790696, 23.21968400203526]
            ]
          ],
          [
            [
              [121.4141886798462, 23.21760696450387],
              [121.4141886798462, 23.21760696450387]
            ]
          ],
          [
            [
              [121.41278776772474, 23.21655851594333],
              [121.41278776772474, 23.21655851594333]
            ]
          ],
          [
            [
              [121.41198830743899, 23.216250619407706],
              [121.41198830743899, 23.216250619407706]
            ]
          ],
          [
            [
              [121.41046774941168, 23.214793948956434],
              [121.41046774941168, 23.214793948956434]
            ]
          ],
          [
            [
              [121.41021891429449, 23.214254891483257],
              [121.41021891429449, 23.214254891483257]
            ]
          ],
          [
            [
              [121.40663185330146, 23.182715886898965],
              [121.40663185330146, 23.182715886898965]
            ]
          ],
          [
            [
              [121.40537644365233, 23.180164549576226],
              [121.40537644365233, 23.180164549576226]
            ]
          ],
          [
            [
              [121.40457317823538, 23.179266495042164],
              [121.40457317823538, 23.179266495042164]
            ]
          ],
          [
            [
              [121.41835384538551, 23.127406963319373],
              [121.41835384538551, 23.127406963319373]
            ]
          ],
          [
            [
              [121.4182236733868, 23.126810343325182],
              [121.4182236733868, 23.126810343325182]
            ]
          ],
          [
            [
              [121.42567710292548, 23.12613782920932],
              [121.42567710292548, 23.12613782920932]
            ]
          ],
          [
            [
              [121.41010303436958, 23.1245800193002],
              [121.41010303436958, 23.1245800193002]
            ]
          ],
          [
            [
              [121.41927922479947, 23.123155329621667],
              [121.41927922479947, 23.123155329621667]
            ]
          ],
          [
            [
              [121.41548106464332, 23.122542261619568],
              [121.41548106464332, 23.122542261619568]
            ]
          ],
          [
            [
              [121.4166886994959, 23.122812743433357],
              [121.4166886994959, 23.122812743433357]
            ]
          ],
          [
            [
              [121.39929100898624, 23.11501513975132],
              [121.39929100898624, 23.11501513975132]
            ]
          ],
          [
            [
              [121.39488802507493, 23.114248300867988],
              [121.39488802507493, 23.114248300867988]
            ]
          ],
          [
            [
              [121.40130209611371, 23.11354230925887],
              [121.40130209611371, 23.11354230925887]
            ]
          ],
          [
            [
              [121.39392897085173, 23.111803687503755],
              [121.39392897085173, 23.111803687503755]
            ]
          ],
          [
            [
              [121.39422532642993, 23.11126104753593],
              [121.39422532642993, 23.11126104753593]
            ]
          ],
          [
            [
              [121.39350052687517, 23.1106351491507],
              [121.39350052687517, 23.1106351491507]
            ]
          ],
          [
            [
              [121.39185774972768, 23.108082016970698],
              [121.39185774972768, 23.108082016970698]
            ]
          ],
          [
            [
              [121.39066020645028, 23.10807550383683],
              [121.39066020645028, 23.10807550383683]
            ]
          ],
          [
            [
              [121.39083089996109, 23.10707974307275],
              [121.39083089996109, 23.10707974307275]
            ]
          ],
          [
            [
              [121.38969894145816, 23.106212673098433],
              [121.38969894145816, 23.106212673098433]
            ]
          ],
          [
            [
              [121.38841713052817, 23.10398844873391],
              [121.38841713052817, 23.10398844873391]
            ]
          ],
          [
            [
              [121.38682861310406, 23.102301347999735],
              [121.38682861310406, 23.102301347999735]
            ]
          ],
          [
            [
              [121.38719079083275, 23.101757177529564],
              [121.38719079083275, 23.101757177529564]
            ]
          ],
          [
            [
              [121.38542782233752, 23.099462963957407],
              [121.38542782233752, 23.099462963957407]
            ]
          ],
          [
            [
              [121.38409815010213, 23.097411363437267],
              [121.38409815010213, 23.097411363437267]
            ]
          ],
          [
            [
              [121.38340786967987, 23.09658352801536],
              [121.38340786967987, 23.09658352801536]
            ]
          ],
          [
            [
              [121.3833809979364, 23.09585154593986],
              [121.3833809979364, 23.09585154593986]
            ]
          ],
          [
            [
              [121.3825876458589, 23.095406253546123],
              [121.3825876458589, 23.095406253546123]
            ]
          ],
          [
            [
              [121.38467380070722, 23.09222004179912],
              [121.38467380070722, 23.09222004179912]
            ]
          ],
          [
            [
              [121.35855551790384, 23.086368573430097],
              [121.35855551790384, 23.086368573430097]
            ]
          ],
          [
            [
              [121.35875407139014, 23.083148156342425],
              [121.35875407139014, 23.083148156342425]
            ]
          ],
          [
            [
              [121.27452416683018, 22.92274815308816],
              [121.27452416683018, 22.92274815308816]
            ]
          ],
          [
            [
              [121.26290175791041, 22.9072620914155],
              [121.26290175791041, 22.9072620914155]
            ]
          ],
          [
            [
              [121.18751450506288, 22.831822621577867],
              [121.18751450506288, 22.831822621577867]
            ]
          ],
          [
            [
              [121.18791361115848, 22.831089863158997],
              [121.18791361115848, 22.831089863158997]
            ]
          ],
          [
            [
              [121.19146328461186, 22.829391946384863],
              [121.19146328461186, 22.829391946384863]
            ]
          ],
          [
            [
              [121.19752661456573, 22.82718906139692],
              [121.19752661456573, 22.82718906139692]
            ]
          ],
          [
            [
              [121.19583571618281, 22.82743596731804],
              [121.19583571618281, 22.82743596731804]
            ]
          ],
          [
            [
              [121.52053637917876, 22.68479187610422],
              [121.52053637917876, 22.68479187610422]
            ]
          ],
          [
            [
              [121.5118793074763, 22.68049369996452],
              [121.5118793074763, 22.68049369996452]
            ]
          ],
          [
            [
              [121.51361448858827, 22.680226231042887],
              [121.51361448858827, 22.680226231042887]
            ]
          ],
          [
            [
              [121.49062116363893, 22.680442141201777],
              [121.49062116363893, 22.680442141201777]
            ]
          ],
          [
            [
              [121.51218729296565, 22.67957150576717],
              [121.51218729296565, 22.67957150576717]
            ]
          ],
          [
            [
              [121.51107606389256, 22.679322174561452],
              [121.51107606389256, 22.679322174561452]
            ]
          ],
          [
            [
              [121.51156132088684, 22.669680516617724],
              [121.51156132088684, 22.669680516617724]
            ]
          ],
          [
            [
              [121.51301583223533, 22.666613772250972],
              [121.51301583223533, 22.666613772250972]
            ]
          ],
          [
            [
              [121.51163757790258, 22.66529426487046],
              [121.51163757790258, 22.66529426487046]
            ]
          ],
          [
            [
              [121.51272357490737, 22.662957335708583],
              [121.51272357490737, 22.662957335708583]
            ]
          ],
          [
            [
              [121.50757545203581, 22.65909637782253],
              [121.50757545203581, 22.65909637782253]
            ]
          ],
          [
            [
              [121.50045247413722, 22.646572487964963],
              [121.50949842989786, 22.633915447484565],
              [121.50949635097842, 22.63385820722313],
              [121.49819382121007, 22.632384080857694],
              [121.49816389065641, 22.632375504149532],
              [121.47307403644281, 22.646136865575162],
              [121.47295155684122, 22.64618898316066],
              [121.46267154521367, 22.674129706045388],
              [121.46266762909218, 22.67421552894958],
              [121.50927837754003, 22.678948109743217],
              [121.50931878415723, 22.678929197064885],
              [121.50045247413722, 22.646572487964963]
            ]
          ],
          [
            [
              [121.50991054520014, 22.653979206048554],
              [121.50991054520014, 22.653979206048554]
            ]
          ],
          [
            [
              [121.50765552999502, 22.64962035854263],
              [121.50765552999502, 22.64962035854263]
            ]
          ],
          [
            [
              [121.50473988475737, 22.642001317813055],
              [121.50473988475737, 22.642001317813055]
            ]
          ],
          [
            [
              [121.50822732498784, 22.632819516865347],
              [121.50822732498784, 22.632819516865347]
            ]
          ],
          [
            [
              [121.44694231083405, 23.443741610581338],
              [121.4954983954133, 23.434689947982367],
              [121.49581945388192, 23.43467538371576],
              [121.46262263999847, 23.314845523668048],
              [121.46274605962844, 23.31456974811331],
              [121.43030715346696, 23.28626336462711],
              [121.43010969547439, 23.286042674392487],
              [121.42017167115235, 23.225948214381884],
              [121.42016483490407, 23.22591249068656],
              [121.39642127315958, 23.204763133965795],
              [121.39624079306778, 23.20433228996597],
              [121.40051077706026, 23.132188500041707],
              [121.40089989391461, 23.1309729180862],
              [121.42473443814603, 23.126382710840915],
              [121.42471977243746, 23.126297909538692],
              [121.36333268553022, 23.093793890422557],
              [121.36306072838089, 23.09350780652166],
              [121.31695042687373, 22.982807146322397],
              [121.31682277124615, 22.982306199925922],
              [121.25102885106222, 22.88616334189807],
              [121.25086573085798, 22.88590385530475],
              [121.18986145137855, 22.848895354852992],
              [121.18969884498111, 22.848669767804537],
              [121.20099608759293, 22.795915795004372],
              [121.20105009382351, 22.795798315820594],
              [121.17410122761869, 22.75677410817167],
              [121.1740105350642, 22.756523461748905],
              [121.02586902026312, 22.65598008572465],
              [121.02555358937073, 22.65548560991396],
              [120.89525995630994, 22.33564910675946],
              [120.89505368343526, 22.33500546265464],
              [120.89625641998435, 22.246587834974065],
              [120.89627582517147, 22.24637777294378],
              [120.8665511449798, 22.22977653673777],
              [120.86625585101834, 22.22980555655451],
              [120.81568444204684, 22.262956414581932],
              [120.81538896917023, 22.263177351673153],
              [120.79814416835137, 22.257733201377345],
              [120.79786808389014, 22.257845761385298],
              [120.805674815405, 22.28385779893431],
              [120.80559115197798, 22.284049708587663],
              [120.77694301690202, 22.302186570477033],
              [120.7768847005726, 22.302809689049415],
              [120.79636849076059, 22.31675579336068],
              [120.79672694292904, 22.31744728564628],
              [120.79283583602647, 22.334780666561798],
              [120.79261294150074, 22.335541407057864],
              [120.7436811702667, 22.367033863417163],
              [120.74346228824089, 22.36734295002843],
              [120.75356366129512, 22.40486732964017],
              [120.75349937629856, 22.405002710893363],
              [120.78954405424062, 22.41761874527658],
              [120.78958240867608, 22.417749749806543],
              [120.77643033755788, 22.44984117437358],
              [120.77617274679069, 22.450188441484958],
              [120.75129494149655, 22.458679715472766],
              [120.75103729700126, 22.459013475787913],
              [120.76431681488287, 22.494244033271276],
              [120.76431519351111, 22.49520134376255],
              [120.73908015048596, 22.553182719224505],
              [120.73907920803903, 22.553683893745955],
              [120.78683733717808, 22.692263786142505],
              [120.78673382772844, 22.692931963369215],
              [120.83576407332808, 22.696697573876953],
              [120.83683241783481, 22.697068957989465],
              [120.84835152967383, 22.71680489816439],
              [120.84858317407462, 22.71697211053213],
              [120.88281454849746, 22.71666683482648],
              [120.883259311832, 22.716877140929025],
              [120.89478366573795, 22.737709540960218],
              [120.89505956425225, 22.73866029175252],
              [120.9035130367891, 22.799205566399884],
              [120.90334780459682, 22.79977885977803],
              [120.86178134004072, 22.82620562686056],
              [120.86163033145407, 22.826359030388403],
              [120.86957491513894, 22.857510407344254],
              [120.8695499337757, 22.857679724946266],
              [120.82894355559806, 22.90351410605395],
              [120.82877007067431, 22.903775821976414],
              [120.8208274523253, 22.961449491595072],
              [120.82080218766029, 22.96189196978316],
              [120.85951122203512, 23.006690939319277],
              [120.86060430048956, 23.00797418478985],
              [120.86142572052795, 23.03049003962698],
              [120.86186946543664, 23.031063821833445],
              [120.8795561331272, 23.034710559418993],
              [120.87984476678761, 23.03519841771771],
              [120.86929003264613, 23.059457283799375],
              [120.8691554498151, 23.05969421805902],
              [120.88934411356986, 23.109287565267817],
              [120.88939168965315, 23.11005983231384],
              [120.87643901556943, 23.15119817326857],
              [120.87639340331197, 23.15134723187201],
              [120.9106210199708, 23.181415668513488],
              [120.91110106677415, 23.182300931409973],
              [120.9155018199024, 23.23751613206035],
              [120.91579957663471, 23.238003954680874],
              [120.97095493702882, 23.281228256726063],
              [120.97213001895706, 23.2819307018915],
              [121.03875659356089, 23.300632737015377],
              [121.03889744078154, 23.30063270214304],
              [121.05886044585101, 23.286615818448624],
              [121.05946023880193, 23.286166419907364],
              [121.0783261271364, 23.233429722483006],
              [121.07907388822801, 23.23274303276664],
              [121.1266996634937, 23.22446981855744],
              [121.12927647048008, 23.223332175952418],
              [121.14507269169255, 23.19965714069416],
              [121.14673781703407, 23.199156779535],
              [121.18908787060272, 23.203904120350234],
              [121.18939786530562, 23.203779677834394],
              [121.21201320127399, 23.14490931478321],
              [121.21194738060586, 23.14421658113226],
              [121.25688790894972, 23.126571862379013],
              [121.25768116504874, 23.12606955465599],
              [121.27218379311267, 23.09821297783109],
              [121.27237372596579, 23.09785605175212],
              [121.3153926962504, 23.109984400329434],
              [121.3158072808179, 23.10971703554842],
              [121.31840157715641, 23.167709032917294],
              [121.31855093665054, 23.16814444100283],
              [121.3768947430657, 23.269524043826085],
              [121.37789501792304, 23.269598486834653],
              [121.3778105091697, 23.300705935906496],
              [121.37784159263667, 23.300893157566225],
              [121.42194734103309, 23.354919917887024],
              [121.42220202341291, 23.355228423880245],
              [121.40005542826893, 23.386410065027594],
              [121.40020177972073, 23.38688827901873],
              [121.44694231083405, 23.443741610581338]
            ]
          ],
          [
            [
              [121.50567342218753, 22.087465458575025],
              [121.50567342218753, 22.087465458575025]
            ]
          ],
          [
            [
              [121.57067092205106, 22.085859731773805],
              [121.57067092205106, 22.085859731773805]
            ]
          ],
          [
            [
              [121.52585567503154, 22.083348602427296],
              [121.52585567503154, 22.083348602427296]
            ]
          ],
          [
            [
              [121.51784280375708, 22.082056551494194],
              [121.51784280375708, 22.082056551494194]
            ]
          ],
          [
            [
              [121.5109542590011, 22.082257541543083],
              [121.5109542590011, 22.082257541543083]
            ]
          ],
          [
            [
              [121.58016900957192, 22.078030155049138],
              [121.58016900957192, 22.078030155049138]
            ]
          ],
          [
            [
              [121.56967822727272, 22.069287061486456],
              [121.56967822727272, 22.069287061486456]
            ]
          ],
          [
            [
              [121.56991838827764, 22.06797846980684],
              [121.56991838827764, 22.06797846980684]
            ]
          ],
          [
            [
              [121.56798651977446, 22.05779745836193],
              [121.56798651977446, 22.05779745836193]
            ]
          ],
          [
            [
              [121.56675270540647, 22.056825189326],
              [121.56675270540647, 22.056825189326]
            ]
          ],
          [
            [
              [121.50765637712517, 22.05201244158708],
              [121.50765637712517, 22.05201244158708]
            ]
          ],
          [
            [
              [121.50944510087314, 22.06919870454923],
              [121.50472846337004, 22.085637249216614],
              [121.50524224642179, 22.085947267493495],
              [121.56811586464298, 22.0867241782913],
              [121.56834021454868, 22.08671436711958],
              [121.56699713927718, 22.04114802667355],
              [121.56707702935722, 22.04091291319436],
              [121.60070585011105, 22.017956417716384],
              [121.60072223957386, 22.017864733301046],
              [121.59347203656769, 22.002914877647875],
              [121.59324655994884, 22.00262223285123],
              [121.57109016679946, 22.002758473925336],
              [121.5704715738424, 22.0027606270033],
              [121.50909623857429, 22.045753796371148],
              [121.50871666942379, 22.045937964322174],
              [121.50944510087314, 22.06919870454923]
            ]
          ],
          [
            [
              [121.54479295818857, 22.026188945247668],
              [121.54479295818857, 22.026188945247668]
            ]
          ],
          [
            [
              [121.54398265537547, 22.025352156338194],
              [121.54398265537547, 22.025352156338194]
            ]
          ],
          [
            [
              [121.53887977765228, 22.0243162743506],
              [121.53887977765228, 22.0243162743506]
            ]
          ],
          [
            [
              [121.60118935880648, 22.020105120689045],
              [121.60118935880648, 22.020105120689045]
            ]
          ],
          [
            [
              [121.19206895511427, 22.83965960032244],
              [121.19206895511427, 22.83965960032244]
            ]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10002001", "COUNTYNAME": "宜兰县", "name": "宜兰县" },
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [121.87445341776403, 24.535626459595925],
              [121.87445341776403, 24.535626459595925]
            ]
          ],
          [
            [
              [121.87422553521748, 24.533865881583644],
              [121.87422553521748, 24.533865881583644]
            ]
          ],
          [
            [
              [121.86132788495479, 24.52752724098167],
              [121.86132788495479, 24.52752724098167]
            ]
          ],
          [
            [
              [121.96539056144378, 24.982680902008454],
              [121.96539056144378, 24.982680902008454]
            ]
          ],
          [
            [
              [121.96492508140656, 24.982329164111444],
              [121.96492508140656, 24.982329164111444]
            ]
          ],
          [
            [
              [121.96474388769789, 24.98207518338451],
              [121.96474388769789, 24.98207518338451]
            ]
          ],
          [
            [
              [121.94160854324075, 24.973131529708954],
              [121.94160854324075, 24.973131529708954]
            ]
          ],
          [
            [
              [121.92193788675475, 24.96087241202997],
              [121.92193788675475, 24.96087241202997]
            ]
          ],
          [
            [
              [121.92001921487218, 24.955469809975668],
              [121.92001921487218, 24.955469809975668]
            ]
          ],
          [
            [
              [121.919009803257, 24.953849749325535],
              [121.919009803257, 24.953849749325535]
            ]
          ],
          [
            [
              [121.91429934018203, 24.951380142382824],
              [121.91429934018203, 24.951380142382824]
            ]
          ],
          [
            [
              [121.91388980183285, 24.951334709353514],
              [121.91388980183285, 24.951334709353514]
            ]
          ],
          [
            [
              [121.90998782084233, 24.948489267158095],
              [121.90998782084233, 24.948489267158095]
            ]
          ],
          [
            [
              [121.90859340297106, 24.94839404068732],
              [121.90859340297106, 24.94839404068732]
            ]
          ],
          [
            [
              [121.90663328552884, 24.94693697480024],
              [121.90663328552884, 24.94693697480024]
            ]
          ],
          [
            [
              [121.90447546908332, 24.945410629800065],
              [121.90447546908332, 24.945410629800065]
            ]
          ],
          [
            [
              [121.90458214935491, 24.94288139890244],
              [121.90458214935491, 24.94288139890244]
            ]
          ],
          [
            [
              [121.90481642289933, 24.941446888720293],
              [121.90481642289933, 24.941446888720293]
            ]
          ],
          [
            [
              [121.90451660895074, 24.940515323535518],
              [121.90451660895074, 24.940515323535518]
            ]
          ],
          [
            [
              [121.89455135855856, 24.938841567189964],
              [121.89455135855856, 24.938841567189964]
            ]
          ],
          [
            [
              [121.88540318201471, 24.920790381623682],
              [121.88540318201471, 24.920790381623682]
            ]
          ],
          [
            [
              [121.88532141533356, 24.919522355806826],
              [121.88532141533356, 24.919522355806826]
            ]
          ],
          [
            [
              [121.88528180200095, 24.91845399063305],
              [121.88528180200095, 24.91845399063305]
            ]
          ],
          [
            [
              [121.8851909917522, 24.91795815522049],
              [121.8851909917522, 24.91795815522049]
            ]
          ],
          [
            [
              [121.88488026174419, 24.9174542631226],
              [121.88488026174419, 24.9174542631226]
            ]
          ],
          [
            [
              [121.88345539333696, 24.916648044471252],
              [121.88345539333696, 24.916648044471252]
            ]
          ],
          [
            [
              [121.88298944630608, 24.9160731251816],
              [121.88298944630608, 24.9160731251816]
            ]
          ],
          [
            [
              [121.88287065240861, 24.915500744538857],
              [121.88287065240861, 24.915500744538857]
            ]
          ],
          [
            [
              [121.88276684129428, 24.91507592454203],
              [121.88276684129428, 24.91507592454203]
            ]
          ],
          [
            [
              [121.87891952276395, 24.91262548487194],
              [121.87891952276395, 24.91262548487194]
            ]
          ],
          [
            [
              [121.87534785015993, 24.909258617828414],
              [121.87534785015993, 24.909258617828414]
            ]
          ],
          [
            [
              [121.87525312862591, 24.908774109561254],
              [121.87525312862591, 24.908774109561254]
            ]
          ],
          [
            [
              [121.8578384159949, 24.89336153070646],
              [121.8578384159949, 24.89336153070646]
            ]
          ],
          [
            [
              [121.85630700048134, 24.89267865745706],
              [121.85630700048134, 24.89267865745706]
            ]
          ],
          [
            [
              [121.85503515116409, 24.89201905347801],
              [121.85503515116409, 24.89201905347801]
            ]
          ],
          [
            [
              [121.85444065563219, 24.89174082549513],
              [121.85444065563219, 24.89174082549513]
            ]
          ],
          [
            [
              [121.85390707056202, 24.89138340622827],
              [121.85390707056202, 24.89138340622827]
            ]
          ],
          [
            [
              [121.85313455843323, 24.891486950600587],
              [121.85313455843323, 24.891486950600587]
            ]
          ],
          [
            [
              [121.85004243021459, 24.88655920973663],
              [121.85004243021459, 24.88655920973663]
            ]
          ],
          [
            [
              [121.84971567207052, 24.885873372043832],
              [121.84971567207052, 24.885873372043832]
            ]
          ],
          [
            [
              [121.84861119077713, 24.884603312628577],
              [121.84861119077713, 24.884603312628577]
            ]
          ],
          [
            [
              [121.84914149245161, 24.88445560684823],
              [121.84914149245161, 24.88445560684823]
            ]
          ],
          [
            [
              [121.84980833862163, 24.884208528408802],
              [121.84980833862163, 24.884208528408802]
            ]
          ],
          [
            [
              [121.84873938075641, 24.884012982023545],
              [121.84873938075641, 24.884012982023545]
            ]
          ],
          [
            [
              [121.84855515847634, 24.883628177882205],
              [121.84855515847634, 24.883628177882205]
            ]
          ],
          [
            [
              [121.96411804013752, 24.837163195374433],
              [121.93451830752552, 24.846217834269968],
              [121.93439436871336, 24.846430852609206],
              [121.96411804013752, 24.837163195374433]
            ]
          ],
          [
            [
              [121.96459461592367, 24.839267069716563],
              [121.96459461592367, 24.839267069716563]
            ]
          ],
          [
            [
              [121.964423041821, 24.838695574240237],
              [121.964423041821, 24.838695574240237]
            ]
          ],
          [
            [
              [121.96443602771653, 24.83724312482039],
              [121.96443602771653, 24.83724312482039]
            ]
          ],
          [
            [
              [121.88064387328085, 24.605561005511927],
              [121.88064387328085, 24.605561005511927]
            ]
          ],
          [
            [
              [121.8816711805228, 24.605091079025076],
              [121.8816711805228, 24.605091079025076]
            ]
          ],
          [
            [
              [121.88929620876608, 24.60523722566812],
              [121.88929620876608, 24.60523722566812]
            ]
          ],
          [
            [
              [121.88726361818591, 24.603515691455964],
              [121.88726361818591, 24.603515691455964]
            ]
          ],
          [
            [
              [121.90160276352701, 24.599840696249043],
              [121.90160276352701, 24.599840696249043]
            ]
          ],
          [
            [
              [121.87017191321439, 24.569515909384858],
              [121.87017191321439, 24.569515909384858]
            ]
          ],
          [
            [
              [121.87495513863206, 24.545624449464434],
              [121.87495513863206, 24.545624449464434]
            ]
          ],
          [
            [
              [121.87405663656786, 24.544165452170372],
              [121.87405663656786, 24.544165452170372]
            ]
          ],
          [
            [
              [121.84524881194487, 24.644644194573626],
              [121.86248627222923, 24.61232769193964],
              [121.86279531913885, 24.61185928980883],
              [121.88547794215137, 24.60337612350939],
              [121.88550472908967, 24.603359570791586],
              [121.85872045613081, 24.60235382370969],
              [121.85819918398525, 24.60088352140777],
              [121.86804373148098, 24.577879961113997],
              [121.86848214216482, 24.577368089499235],
              [121.88069416283534, 24.593346327468314],
              [121.88090282451248, 24.593215182327025],
              [121.87373784975038, 24.534618404507626],
              [121.87372828644506, 24.53445402837129],
              [121.84042762683633, 24.51827605346837],
              [121.83990137377985, 24.51690893541856],
              [121.86150278076869, 24.480892514831943],
              [121.86175421883462, 24.480466604639357],
              [121.82146023173982, 24.4626536183761],
              [121.82121160365978, 24.46248344752174],
              [121.7995733548562, 24.431770207999637],
              [121.7993874260874, 24.431412326285407],
              [121.7726959524991, 24.313625869411656],
              [121.77246978092286, 24.313496023337912],
              [121.67515878094673, 24.33763041435094],
              [121.67484253783806, 24.337753619189865],
              [121.63145554816704, 24.37039015948735],
              [121.63112750778961, 24.370517928530234],
              [121.62041926491386, 24.363537734978443],
              [121.62037611846488, 24.363217479545135],
              [121.63289737948274, 24.334909984710524],
              [121.63271274669704, 24.334689629923005],
              [121.61993347179835, 24.345445775368837],
              [121.61954152452263, 24.34547003893695],
              [121.59584137425652, 24.331818172377368],
              [121.59570696062164, 24.331588536318396],
              [121.60587154613386, 24.3094951638492],
              [121.60576263895766, 24.309448196697534],
              [121.54660241093652, 24.337207957226916],
              [121.54522813138213, 24.337709238621915],
              [121.49652331801984, 24.33999262848258],
              [121.49524781949191, 24.34037133615773],
              [121.43731229796974, 24.383313752162525],
              [121.43685353441, 24.38348199368383],
              [121.37330720643223, 24.368412963421484],
              [121.37304862766588, 24.368474636096774],
              [121.36421515312676, 24.389345071877198],
              [121.36400703648768, 24.389505755482304],
              [121.3263252989008, 24.399259171522882],
              [121.32568461559501, 24.400057179979104],
              [121.3172459749624, 24.4416219069066],
              [121.31673917059453, 24.441708662907377],
              [121.4014158256162, 24.528835754750673],
              [121.40153324590958, 24.529002384852596],
              [121.40302476368747, 24.59172537713487],
              [121.40314112211249, 24.59202516250261],
              [121.4274168152302, 24.605575179930888],
              [121.42761095024775, 24.605766479202227],
              [121.4591560586266, 24.672807537384465],
              [121.45949478471809, 24.673142816448593],
              [121.49308395644034, 24.673240867835762],
              [121.49349457836435, 24.673370514645562],
              [121.57467176981116, 24.710074278535252],
              [121.57494018727557, 24.71019477294723],
              [121.59761956906061, 24.728177994347675],
              [121.59791598030925, 24.72885841100395],
              [121.59195517294117, 24.787590758932435],
              [121.59199557065811, 24.78765822132885],
              [121.62524545589461, 24.79497014004479],
              [121.62542825436061, 24.79505966806165],
              [121.62569195230685, 24.80868279571499],
              [121.62579692490516, 24.808781676551305],
              [121.68785470150874, 24.816050746126884],
              [121.68822564718884, 24.816107822150304],
              [121.73016297743847, 24.85508849113489],
              [121.73051608630014, 24.85529903308575],
              [121.7749747068177, 24.86495891277693],
              [121.77545341249905, 24.865109470746052],
              [121.79177015556786, 24.89967962209937],
              [121.79185248246483, 24.899782988465017],
              [121.83145095967134, 24.904838094162997],
              [121.83172163896806, 24.90488172458996],
              [121.8528388007613, 24.924512260966594],
              [121.85362703138354, 24.925162221805994],
              [121.83918199229079, 24.944250341467676],
              [121.83903392233431, 24.944686858042694],
              [121.84671092457299, 24.960162408485342],
              [121.84691766584696, 24.960296658836818],
              [121.96534664516444, 24.98395062612047],
              [121.96600414892819, 24.983106831632487],
              [121.88943620971736, 24.93722186705722],
              [121.8891261266549, 24.93696191255466],
              [121.8330474006219, 24.864220221866912],
              [121.83266400891996, 24.863411164534536],
              [121.81778318141662, 24.776407195403856],
              [121.81778219492567, 24.77625663093277],
              [121.84524881194487, 24.644644194573626]
            ]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "63000001", "COUNTYNAME": "台北市", "name": "台北市" },
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [121.55916455083678, 25.21013448717874],
            [121.58337797126816, 25.194795086200678],
            [121.58374128576618, 25.19458142632804],
            [121.57701038046915, 25.167266267443022],
            [121.5770407017002, 25.166990708483887],
            [121.60741667792075, 25.13034833769368],
            [121.60784391128328, 25.13019762566689],
            [121.59699045934731, 25.110610603243696],
            [121.59749514786878, 25.109509491909726],
            [121.62588212862421, 25.09660816010844],
            [121.62622594793704, 25.096044721173907],
            [121.6170342370004, 25.047209540626863],
            [121.61909826689865, 25.04345860874424],
            [121.665903271865, 25.029927621673988],
            [121.66592789309509, 25.02984165553567],
            [121.59746870791497, 25.01473736730789],
            [121.5973865892381, 25.014658611547997],
            [121.59932195307789, 24.978619952571517],
            [121.59950806678548, 24.978127199357523],
            [121.61999628973449, 24.969435115301618],
            [121.62000241683319, 24.969360698431494],
            [121.59764735195232, 24.960602785648664],
            [121.5972064414741, 24.96049410440127],
            [121.5616443438812, 24.964658941634976],
            [121.56124211221821, 24.96468310976385],
            [121.53537389215177, 24.9950493803115],
            [121.53526582786752, 24.995115123786867],
            [121.5273774747525, 24.987002876896725],
            [121.52681182032737, 24.98704558831632],
            [121.53255371168368, 25.006466470839044],
            [121.53248714634468, 25.007017424623452],
            [121.51917142916825, 25.019591397745977],
            [121.51848704711031, 25.01993698094887],
            [121.48956926085016, 25.013161118938644],
            [121.4889191024833, 25.013971205510764],
            [121.50624685156475, 25.07392305123608],
            [121.50607386499532, 25.07472028658913],
            [121.46131595958086, 25.103909402657173],
            [121.46013572568978, 25.104790940289547],
            [121.45931923519827, 25.12201265909591],
            [121.45878480958676, 25.122957690881346],
            [121.55916455083678, 25.21013448717874]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10009001", "COUNTYNAME": "云林县", "name": "云林县" },
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [120.13009758002833, 23.568902455738236],
              [120.13009758002833, 23.568902455738236]
            ]
          ],
          [
            [
              [120.10812049577262, 23.539621996669993],
              [120.13303198088472, 23.56386183888387],
              [120.13303316296253, 23.563518729028026],
              [120.10812049577262, 23.539621996669993]
            ]
          ],
          [
            [
              [120.13185897484517, 23.530129519364007],
              [120.13185897484517, 23.530129519364007]
            ]
          ],
          [
            [
              [120.0974498870625, 23.521348112105926],
              [120.09637566741716, 23.541261424871212],
              [120.09665465139634, 23.541434602541937],
              [120.11149956509425, 23.529934333853397],
              [120.11162439426117, 23.529709311848002],
              [120.0974498870625, 23.521348112105926]
            ]
          ],
          [
            [
              [120.0598454365262, 23.489558772383507],
              [120.0429902536724, 23.47667918821282],
              [120.04286678868532, 23.476705518251947],
              [120.04536975462209, 23.49385026649356],
              [120.04524550114063, 23.493822417269328],
              [120.02428434601917, 23.460066098217354],
              [120.02388126102106, 23.459521790833357],
              [120.00963707091083, 23.464840878868838],
              [120.0088928709607, 23.463842868040487],
              [120.02060409932497, 23.435978944708804],
              [120.02032536330303, 23.435688248222903],
              [119.99696257273476, 23.46537607347057],
              [119.99690879959732, 23.46575281622008],
              [120.080367124148, 23.525537777591218],
              [120.08092390240371, 23.526281616006298],
              [120.09598523627783, 23.510865262277846],
              [120.09580434916731, 23.510539154533056],
              [120.0598454365262, 23.489558772383507]
            ]
          ],
          [
            [
              [120.1923108413581, 23.817642912067488],
              [120.1923108413581, 23.817642912067488]
            ]
          ],
          [
            [
              [120.19258930001489, 23.816934161712012],
              [120.19258930001489, 23.816934161712012]
            ]
          ],
          [
            [
              [120.19100990537797, 23.816022361183727],
              [120.19100990537797, 23.816022361183727]
            ]
          ],
          [
            [
              [120.17165293914782, 23.740801353230403],
              [120.17165293914782, 23.740801353230403]
            ]
          ],
          [
            [
              [120.17421973306831, 23.74223988246234],
              [120.17421973306831, 23.74223988246234]
            ]
          ],
          [
            [
              [120.16964057489506, 23.73486027838196],
              [120.15724023245069, 23.717651527883433],
              [120.15718912894825, 23.718053330725905],
              [120.16964057489506, 23.73486027838196]
            ]
          ],
          [
            [
              [120.64450413335379, 23.66820013521875],
              [120.63070818114855, 23.62225283748479],
              [120.63083197433133, 23.622038491484208],
              [120.65256701637965, 23.629639181146377],
              [120.65290438116901, 23.62958124192271],
              [120.66811770969092, 23.609173121685146],
              [120.66910834678593, 23.60917975120054],
              [120.71825600882332, 23.629951286865737],
              [120.71854133111786, 23.6299293202005],
              [120.73605133868924, 23.570773706169323],
              [120.73615378063558, 23.570448781492516],
              [120.65055403024502, 23.572517201007713],
              [120.6502689503532, 23.572559957831807],
              [120.64864056687104, 23.593394483787865],
              [120.64855216107743, 23.59341911611437],
              [120.58066811989563, 23.58224848294248],
              [120.58029867085006, 23.58225886315354],
              [120.5332113295051, 23.596948681398608],
              [120.53311979957554, 23.596941724190195],
              [120.50426449672786, 23.635124362279118],
              [120.50376039290373, 23.6352762656049],
              [120.42551584877904, 23.618026643078547],
              [120.42522147447954, 23.618009751167957],
              [120.4047543209492, 23.634181328069612],
              [120.40460620678193, 23.63418744160029],
              [120.29080991010589, 23.56288341175431],
              [120.29020975461671, 23.562424803901923],
              [120.27249641826222, 23.531324119152917],
              [120.27196179245522, 23.53075952492428],
              [120.24440912190423, 23.544303093687756],
              [120.24355058548021, 23.543757156162748],
              [120.24686700688936, 23.514303786732366],
              [120.24663669065082, 23.513801457040884],
              [120.22458539120424, 23.504559925734792],
              [120.2230390163588, 23.50430841232954],
              [120.1463669357867, 23.5207397495498],
              [120.14584068776958, 23.520804584067026],
              [120.13313052694546, 23.615686031038578],
              [120.13312971079777, 23.6158100983836],
              [120.16246107316576, 23.68202031375576],
              [120.16318546900602, 23.68334906147222],
              [120.18621746309584, 23.69989231748872],
              [120.18678428802781, 23.70075531108619],
              [120.15943687792698, 23.7188030239848],
              [120.15949051352605, 23.71894552603843],
              [120.20494028072285, 23.77900643293434],
              [120.20496700393193, 23.77909912031884],
              [120.17129395791079, 23.7552243845144],
              [120.17119472316062, 23.755115501588676],
              [120.16189680987789, 23.779700061336506],
              [120.16191381994162, 23.779892032780033],
              [120.16977772236568, 23.77062738508179],
              [120.1723656406763, 23.769420038794937],
              [120.1847399648057, 23.798118203775513],
              [120.18535156731734, 23.800579631984647],
              [120.156850178582, 23.78438593724942],
              [120.15674021273739, 23.784536656404313],
              [120.19923868321001, 23.82263203153667],
              [120.19961642983034, 23.82327723228029],
              [120.23159429604625, 23.816811896904508],
              [120.23170861980654, 23.81687792850974],
              [120.21288103052515, 23.821769841962492],
              [120.21275086282182, 23.82196782905073],
              [120.2276766439311, 23.84670271787315],
              [120.22793238033756, 23.846841658851407],
              [120.30413542511499, 23.82135636375166],
              [120.30814032834708, 23.82029746489297],
              [120.4282208814524, 23.830312937851755],
              [120.43314965453851, 23.83015730517283],
              [120.50813506576156, 23.800607679445104],
              [120.50883019569582, 23.800424868488765],
              [120.63996048603666, 23.786095656400146],
              [120.6403502196714, 23.786038160718185],
              [120.65578077935989, 23.754730110824923],
              [120.65597145989256, 23.753750969492565],
              [120.6558198031921, 23.735083502581844],
              [120.65571255833105, 23.734834926870985],
              [120.63979862258273, 23.72949881272242],
              [120.63970736392392, 23.729189194936776],
              [120.64450413335379, 23.66820013521875]
            ]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10003001", "COUNTYNAME": "桃园县", "name": "桃园县" },
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [121.18979962366132, 25.093617942071088],
            [121.26037875612174, 25.121992331474612],
            [121.26068090579248, 25.121976001136307],
            [121.4006560608117, 25.051397064594106],
            [121.40068754424563, 25.05136311497609],
            [121.3906623942336, 25.041966338819964],
            [121.3906620796172, 25.041867029488987],
            [121.41212619627017, 25.01943143591994],
            [121.41215482838442, 25.01910417428439],
            [121.39118902738723, 25.01215519063433],
            [121.3911760965165, 25.01208065145386],
            [121.40315299566664, 24.999215340698456],
            [121.40294762153161, 24.998994723310986],
            [121.36971168033837, 24.977088966542105],
            [121.36933311727162, 24.976898073164232],
            [121.32383606424338, 24.972916680645703],
            [121.32354623954771, 24.972750377088847],
            [121.33159895260953, 24.945780743810598],
            [121.33160476011294, 24.94563861562157],
            [121.31618567035947, 24.938780431472125],
            [121.31577677739695, 24.93847666322876],
            [121.33870775627075, 24.92847499030528],
            [121.33977551603363, 24.928497397503012],
            [121.31777319142176, 24.916597899944716],
            [121.3175556783441, 24.916347789237534],
            [121.32036965280932, 24.900298002092185],
            [121.32031930341168, 24.900207817050113],
            [121.35421728526313, 24.87394632572198],
            [121.3543673636316, 24.87364584677194],
            [121.34524846714608, 24.867312872516088],
            [121.34504640124126, 24.866940952594003],
            [121.35814811221476, 24.853421189199846],
            [121.35803187427665, 24.853220476542152],
            [121.3359103462407, 24.844045824598815],
            [121.33608201614777, 24.843835409328992],
            [121.37324707054788, 24.833340147994665],
            [121.37356102564951, 24.833273808153017],
            [121.40272642658248, 24.843527495466212],
            [121.40296711918333, 24.843468161888808],
            [121.43639610245724, 24.81219296594137],
            [121.43655909076487, 24.812038997862874],
            [121.44957478949338, 24.78626586762417],
            [121.44952080015618, 24.786035894308966],
            [121.42325676893256, 24.76224694741773],
            [121.42330173565199, 24.761899222754185],
            [121.47963583687351, 24.674638977902735],
            [121.47984561768031, 24.673776169849788],
            [121.44961480174351, 24.662270968010645],
            [121.44953702307149, 24.662192200410665],
            [121.424708502938, 24.603244567613974],
            [121.42455588721374, 24.603100548010847],
            [121.39256187428892, 24.586733220520458],
            [121.39147434294279, 24.586460593581048],
            [121.37364676936969, 24.593301984229345],
            [121.37283696630773, 24.59368545623868],
            [121.35369319440998, 24.667045746028023],
            [121.35357843787091, 24.66762840158811],
            [121.33967088160368, 24.66619070211645],
            [121.33920308212417, 24.666521414258472],
            [121.3244016406684, 24.69479295943718],
            [121.32392546465238, 24.69504002766734],
            [121.29963337101631, 24.695339069282916],
            [121.29955011913374, 24.695522084061448],
            [121.30160160669453, 24.762888588170014],
            [121.30139293409829, 24.763103527384203],
            [121.26024186979124, 24.781856708271228],
            [121.26001585706226, 24.78195641539203],
            [121.2437633385917, 24.808467482308867],
            [121.24348736492273, 24.80866204578784],
            [121.22171584711123, 24.799389565055098],
            [121.22163199864558, 24.799342289210497],
            [121.15004287176951, 24.84426661516025],
            [121.14996471226108, 24.844325288907733],
            [121.15576701249707, 24.880594867110982],
            [121.15571048441232, 24.880653611368874],
            [121.05865469645526, 24.90500729409691],
            [121.05794356321077, 24.905454572772083],
            [121.04612155459282, 24.943125863060867],
            [121.04627272928238, 24.943536547447362],
            [120.98710683701928, 24.93915493947422],
            [120.98603570111636, 24.939448358065867],
            [121.05160049702043, 25.041608990395684],
            [121.05187748857543, 25.041873071897335],
            [121.18979962366132, 25.093617942071088]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10013001", "COUNTYNAME": "屏东县", "name": "屏东县" },
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [120.70254097053987, 22.055656509457584],
              [120.70254097053987, 22.055656509457584]
            ]
          ],
          [
            [
              [120.35878313463898, 22.321686188884627],
              [120.36618272915575, 22.350935156470136],
              [120.36651036383313, 22.35125477456037],
              [120.38968739464865, 22.348067690444733],
              [120.38971091920517, 22.347891582217894],
              [120.35878313463898, 22.321686188884627]
            ]
          ],
          [
            [
              [120.88925384085276, 22.130492579293396],
              [120.88925384085276, 22.130492579293396]
            ]
          ],
          [
            [
              [120.8876725716315, 22.12607088663004],
              [120.8876725716315, 22.12607088663004]
            ]
          ],
          [
            [
              [120.69254596217262, 22.009621056284804],
              [120.68611944172818, 22.029084186649765],
              [120.68622478094984, 22.02991534340689],
              [120.71603151315286, 22.105058219049724],
              [120.71611016427734, 22.10511029680762],
              [120.6862909774712, 22.20752825205036],
              [120.68578852880303, 22.2087712407678],
              [120.64936437331613, 22.255711994268815],
              [120.64934226747125, 22.255712714246584],
              [120.64273743455067, 22.302533696250208],
              [120.64249731388261, 22.303088670443714],
              [120.58494004260248, 22.372300174745707],
              [120.58459905541818, 22.372565812844357],
              [120.45344127755847, 22.446775422183464],
              [120.45237593829191, 22.445929610343168],
              [120.42476024431637, 22.477186776843055],
              [120.4240574512121, 22.47702838409176],
              [120.422896221351, 22.514037724806908],
              [120.4228185278917, 22.514899839800464],
              [120.44411877552415, 22.56883242169388],
              [120.44437978977966, 22.569894701366096],
              [120.43594791872525, 22.659500313269227],
              [120.43608125790152, 22.661415251501023],
              [120.47533122116118, 22.83758120371391],
              [120.47619325118026, 22.838166437202823],
              [120.55222173689467, 22.828296677304714],
              [120.55322681475815, 22.828382952094586],
              [120.61307761304681, 22.87612997664469],
              [120.61425268940216, 22.87650979166767],
              [120.65556013771555, 22.881638904231288],
              [120.6558608465034, 22.881610105951946],
              [120.67161712245198, 22.85641259223426],
              [120.67222800463361, 22.856368733549974],
              [120.72010459635858, 22.881903475757706],
              [120.72044508421193, 22.88199881674206],
              [120.77836830551223, 22.835288288817797],
              [120.77880568459096, 22.83518954813504],
              [120.82405936770279, 22.86621592818718],
              [120.82431505310745, 22.866299746154443],
              [120.8530371805346, 22.857595444258173],
              [120.8531609509878, 22.857604589373185],
              [120.86842628296186, 22.817132402893876],
              [120.8685703390177, 22.816913512715814],
              [120.90085375704994, 22.804502964060475],
              [120.90169581441795, 22.803250477202088],
              [120.8854722836915, 22.71947081314372],
              [120.8837998875535, 22.717295337836084],
              [120.85009006742723, 22.71697353014975],
              [120.84858317407462, 22.71697211053213],
              [120.80934833063584, 22.68841352587162],
              [120.80908158912536, 22.688232577844612],
              [120.78695239176666, 22.693124173089974],
              [120.78673382772844, 22.692931963369215],
              [120.73927958678127, 22.554497069595662],
              [120.73907920803903, 22.553683893745955],
              [120.76426312437391, 22.495546713019422],
              [120.76431519351111, 22.49520134376255],
              [120.75097217367795, 22.45943116262047],
              [120.75103729700126, 22.459013475787913],
              [120.77573478272008, 22.450445325191616],
              [120.77617274679069, 22.450188441484958],
              [120.78884050100467, 22.418545916048753],
              [120.78958240867608, 22.417749749806543],
              [120.75360416763021, 22.40504802738392],
              [120.75349937629856, 22.405002710893363],
              [120.74350762031902, 22.367525835164766],
              [120.74346228824089, 22.36734295002843],
              [120.79230747367717, 22.335927037799053],
              [120.79261294150074, 22.335541407057864],
              [120.79686751574447, 22.31798703762814],
              [120.79672694292904, 22.31744728564628],
              [120.77767164719, 22.29814828793583],
              [120.77776048515041, 22.29787745623429],
              [120.8054111088716, 22.284198431455778],
              [120.80559115197798, 22.284049708587663],
              [120.79847836864403, 22.257480724224457],
              [120.7990821248157, 22.257118024862834],
              [120.8152412385799, 22.26322469864015],
              [120.81538896917023, 22.263177351673153],
              [120.86210961811453, 22.230655552295293],
              [120.86215451864787, 22.230619464017686],
              [120.89331596549764, 22.24569187839419],
              [120.89627582517147, 22.24637777294378],
              [120.89903893111789, 22.234248147660903],
              [120.89927144894479, 22.234033800639796],
              [120.89692982263055, 22.14368472147106],
              [120.89708092810585, 22.14338901099766],
              [120.8852492810184, 22.131889871357306],
              [120.88524453727621, 22.131761157284746],
              [120.90191661477805, 22.105398762964956],
              [120.90204236012272, 22.105349154846813],
              [120.8907090171154, 22.086849959468164],
              [120.8907067076852, 22.08681731718142],
              [120.90126978430922, 22.03417519451982],
              [120.90125924306967, 22.03409615982974],
              [120.87565375892098, 22.000712046401787],
              [120.87578747503456, 22.00026956944296],
              [120.8451055712909, 21.988304788638025],
              [120.84490694049401, 21.988103633397216],
              [120.8409603192899, 21.959889669997356],
              [120.84074126562618, 21.959313648534774],
              [120.86642341385458, 21.900907098616077],
              [120.8663094255175, 21.900367320055867],
              [120.76621300034078, 21.95903262283363],
              [120.766129736532, 21.959059599842956],
              [120.72714961861837, 21.91876658208705],
              [120.72656977901185, 21.91909981657091],
              [120.71122413940174, 21.934245219735256],
              [120.71116547591731, 21.934378345440976],
              [120.71429600377698, 21.980629185224586],
              [120.71432255761255, 21.98082117519676],
              [120.69254596217262, 22.009621056284804]
            ]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10006001", "COUNTYNAME": "台中市", "name": "台中市" },
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [120.52977575271069, 24.315693396235336],
              [120.52977575271069, 24.315693396235336]
            ]
          ],
          [
            [
              [120.53480355072584, 24.3161732271144],
              [120.53480355072584, 24.3161732271144]
            ]
          ],
          [
            [
              [120.48238494102522, 24.236537112460248],
              [120.50651121955403, 24.28032602578157],
              [120.508013710953, 24.283238422342254],
              [120.49268994685335, 24.297079939407563],
              [120.49279560226186, 24.29725863280963],
              [120.51104779347183, 24.292650464504796],
              [120.51121007038755, 24.292721051756658],
              [120.51952995704781, 24.312948911318564],
              [120.51959237396339, 24.312971681289355],
              [120.54901427996082, 24.305964935124795],
              [120.54940589901989, 24.30579227957339],
              [120.53873800588882, 24.32255722552484],
              [120.53874400846354, 24.322643019281273],
              [120.55298479439126, 24.324525237241577],
              [120.55302849569387, 24.324577192452438],
              [120.56133358951107, 24.359259597289544],
              [120.56143907714929, 24.35953075366806],
              [120.62114117678921, 24.44092033079614],
              [120.62117546748395, 24.44094524622248],
              [120.69230326797356, 24.36761355459315],
              [120.69276390982127, 24.3671475240674],
              [120.83764248919876, 24.28935299145327],
              [120.83793035953278, 24.289312576991573],
              [120.91159780200904, 24.293925994445505],
              [120.91183956024862, 24.29401868445068],
              [120.91632997597875, 24.334638203819246],
              [120.91634962758512, 24.334728506410812],
              [120.93508977202741, 24.34275598266284],
              [120.93566937080828, 24.342855550386474],
              [121.00291370448558, 24.33268134037697],
              [121.00359776503879, 24.332482683639135],
              [121.04852154458746, 24.295962077165928],
              [121.04882789258166, 24.295971008248312],
              [121.07284068115098, 24.322815863604976],
              [121.07286579104276, 24.32283842453333],
              [121.09145581612863, 24.318547966981004],
              [121.0916767847762, 24.318577259859694],
              [121.14047438022133, 24.359477600439295],
              [121.14061650953296, 24.35959927173276],
              [121.16767469175747, 24.360794454307968],
              [121.16797586234145, 24.360976870470502],
              [121.19656980393655, 24.396540552061516],
              [121.19662909545153, 24.39662850856685],
              [121.23065535201901, 24.38367487127803],
              [121.23123979971663, 24.383865848340008],
              [121.24502289984545, 24.42254693955703],
              [121.24519858081474, 24.42272056304149],
              [121.31581799685046, 24.440631582668743],
              [121.31673917059453, 24.441708662907377],
              [121.3263252989008, 24.399259171522882],
              [121.32660801451367, 24.398847787384398],
              [121.36376515174229, 24.389567291222075],
              [121.36400703648768, 24.389505755482304],
              [121.37270955314551, 24.368712364383494],
              [121.37304862766588, 24.368474636096774],
              [121.43195537923415, 24.383863839558906],
              [121.43269831324251, 24.38390704516166],
              [121.44991017927553, 24.36794287136046],
              [121.45099901378815, 24.365395636699976],
              [121.43392681361838, 24.3225352157716],
              [121.43374245435854, 24.322289602390804],
              [121.38038006705676, 24.280754431673284],
              [121.38005364032513, 24.280296903265693],
              [121.38475867852671, 24.255784353594276],
              [121.38463291732309, 24.255516144997085],
              [121.35351235921821, 24.24457145905369],
              [121.3521607802049, 24.244283401989133],
              [121.34274408963073, 24.2242377998432],
              [121.3426922836257, 24.224079905348123],
              [121.28002347295232, 24.230274794562497],
              [121.27980182734987, 24.230227717341187],
              [121.26493064587399, 24.24621963059723],
              [121.26461380398298, 24.246281038872212],
              [121.23777467392745, 24.220220950219456],
              [121.23767464362308, 24.22019862349567],
              [121.21967820556554, 24.229720960812994],
              [121.21951975093323, 24.229721189370725],
              [121.18156423119497, 24.212629085278063],
              [121.18130578082135, 24.21263842241787],
              [121.16760363220494, 24.225931266868546],
              [121.16748669565301, 24.225931395542656],
              [121.05338349087413, 24.15634865662387],
              [121.05235829785184, 24.155592773200958],
              [121.01958946074203, 24.159690812950117],
              [121.01939784241114, 24.159591514147515],
              [120.98934100777498, 24.118855415600045],
              [120.98904125699676, 24.118710923382565],
              [120.95041920973871, 24.127795907406934],
              [120.94989435471588, 24.12784991266722],
              [120.9200103439155, 24.10756122142289],
              [120.91973559492813, 24.107432407767767],
              [120.89223131151591, 24.116151493220663],
              [120.8915353413831, 24.115900515276817],
              [120.87834859350002, 24.08514746956804],
              [120.87808672157152, 24.084984730672655],
              [120.87916906891164, 24.109119287916318],
              [120.87915587810265, 24.10925471902629],
              [120.84539094508737, 24.124549513055353],
              [120.84484755133373, 24.12451970676172],
              [120.82941965388798, 24.071545894840213],
              [120.82933237419938, 24.071430590531314],
              [120.7472067390785, 23.998998701342973],
              [120.74599138832089, 23.998486416684514],
              [120.6252872631811, 24.030051449944757],
              [120.62513081920378, 24.03018426908761],
              [120.61246197384949, 24.102283237058135],
              [120.61251115074064, 24.102540697328205],
              [120.53310422045757, 24.126033430497166],
              [120.53274019008937, 24.126287492241328],
              [120.49750675910805, 24.193472299579312],
              [120.48590467268795, 24.197417093735208],
              [120.49389636891078, 24.21357318480026],
              [120.49390229735293, 24.21362954602391],
              [120.46143800402757, 24.215373806724916],
              [120.46078067654922, 24.215601739982457],
              [120.48238494102522, 24.236537112460248]
            ]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10011001", "COUNTYNAME": "台南市", "name": "台南市" },
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [120.57824132019417, 23.214778702494204],
            [120.59240149947884, 23.239792429496223],
            [120.59248835580962, 23.239846836600616],
            [120.60821563542538, 23.224648814383315],
            [120.60983067356005, 23.222627805191813],
            [120.65415240353265, 23.22439378658024],
            [120.65433934095198, 23.224301546148272],
            [120.63621910257572, 23.175309868184172],
            [120.63617426320481, 23.175131332718212],
            [120.55500864002705, 23.069693904046105],
            [120.55455462285924, 23.06890685682786],
            [120.47997139221623, 23.00274527846753],
            [120.47989100581343, 23.002681801185233],
            [120.4608765354952, 23.00396229133333],
            [120.46033771403366, 23.003386787637837],
            [120.41673290632083, 22.91667362121761],
            [120.4164958938216, 22.916345403986234],
            [120.38175681806865, 22.921179622260226],
            [120.38158988333205, 22.921138335247626],
            [120.352080710751, 22.88759710187287],
            [120.35196150713729, 22.88749051718809],
            [120.2852111967427, 22.904612888733283],
            [120.28445548976245, 22.904742775450547],
            [120.25465506941552, 22.89415844170187],
            [120.25399308971227, 22.894311009946755],
            [120.23024549267103, 22.91674477471263],
            [120.22952423928002, 22.916905989554795],
            [120.17606617546888, 22.912067779438146],
            [120.17503992092708, 22.911751354531273],
            [120.1500819471435, 22.986136332467424],
            [120.15000135254498, 22.986246861507567],
            [120.03166489601507, 23.072794162175324],
            [120.0315907698773, 23.073384118288786],
            [120.1166169749422, 23.338994169686977],
            [120.11696410443724, 23.33955406676855],
            [120.17813643146604, 23.292135451811742],
            [120.17857162719923, 23.29179684902677],
            [120.21189740378507, 23.29270053765475],
            [120.21235384962321, 23.291673404788433],
            [120.2656661379135, 23.35227015595933],
            [120.26610751956493, 23.352644805258223],
            [120.28608531286339, 23.350189335108833],
            [120.28622734737549, 23.350289311103623],
            [120.2921683354172, 23.37431491485756],
            [120.29274542076526, 23.37529731599744],
            [120.34708376901284, 23.400577507590423],
            [120.34862761967868, 23.401096376479988],
            [120.43975532236226, 23.413643165270965],
            [120.43987575097891, 23.413727124246392],
            [120.47924044053583, 23.387698395280626],
            [120.47937628076666, 23.387595002212098],
            [120.49471727400986, 23.394440364486563],
            [120.49492414674783, 23.394350732552397],
            [120.48385511028629, 23.36979312847506],
            [120.48395301052834, 23.36957447244694],
            [120.50448892013223, 23.36903071279085],
            [120.50484920451753, 23.368898578405084],
            [120.50508358510294, 23.344949114772895],
            [120.50507793953156, 23.344822684435105],
            [120.53943024752266, 23.328670487281855],
            [120.53997653608121, 23.327908971535813],
            [120.52268818670584, 23.311942486544183],
            [120.52252506210996, 23.31175903866353],
            [120.53204551740102, 23.255422418012017],
            [120.53228831108288, 23.25515224320755],
            [120.51898926271107, 23.23920583308518],
            [120.51903123279514, 23.23899826597423],
            [120.57824132019417, 23.214778702494204]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10017001", "COUNTYNAME": "基隆市", "name": "基隆市" },
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [121.78196304432356, 25.18913554912561],
              [121.78196304432356, 25.18913554912561]
            ]
          ],
          [
            [
              [121.73790116870128, 25.16102663951191],
              [121.73790116870128, 25.16102663951191]
            ]
          ],
          [
            [
              [121.77994492093491, 25.152140345445595],
              [121.77994492093491, 25.152140345445595]
            ]
          ],
          [
            [
              [121.78307573496252, 25.15185033159591],
              [121.78307573496252, 25.15185033159591]
            ]
          ],
          [
            [
              [121.73386615692426, 25.15875384454109],
              [121.8081604663614, 25.147166409430326],
              [121.8081846179129, 25.147021835639013],
              [121.79775924149567, 25.114306536483483],
              [121.79765786156646, 25.11423268483667],
              [121.7501400799862, 25.10984038377253],
              [121.75002640338222, 25.10974381117797],
              [121.77566132427926, 25.070144403715677],
              [121.77571073298431, 25.070022252684346],
              [121.74339442083017, 25.052576636880893],
              [121.74325547013986, 25.05249155887467],
              [121.65587903751675, 25.093341184328903],
              [121.65569062359438, 25.093450351845554],
              [121.62688601941929, 25.139445868822545],
              [121.62678703069638, 25.13960418499722],
              [121.7089961138804, 25.17557838285585],
              [121.70933947741082, 25.175985305302326],
              [121.70716635534183, 25.164894174649685],
              [121.70724782390695, 25.164830591302067],
              [121.73386615692426, 25.15875384454109]
            ]
          ],
          [
            [
              [121.78328577228508, 25.194976635773656],
              [121.78328577228508, 25.194976635773656]
            ]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "09007001", "COUNTYNAME": "连江县", "name": "连江县" },
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [119.97043746883782, 26.16379429833892],
              [119.94747841007322, 26.141898565019506],
              [119.94746663404607, 26.14188856671944],
              [119.91424024763637, 26.144039040751505],
              [119.91421284859227, 26.14406684452022],
              [119.92215030073002, 26.174198755342104],
              [119.92219041563388, 26.174224057725645],
              [119.94091452783363, 26.153672650090623],
              [119.94091485924334, 26.15367192162711],
              [119.97043746883782, 26.16379429833892]
            ],
            [
              [119.97036578293314, 26.164056158843703],
              [119.97036578293314, 26.164056158843703]
            ],
            [
              [119.96984097440188, 26.163749581903755],
              [119.96984097440188, 26.163749581903755]
            ],
            [
              [119.96990125609386, 26.16379015141254],
              [119.96990125609386, 26.16379015141254]
            ]
          ],
          [
            [
              [120.00377959690611, 26.248437557810696],
              [120.00377959690611, 26.248437557810696]
            ]
          ],
          [
            [
              [120.01212494036882, 26.24966072719508],
              [120.01212494036882, 26.24966072719508]
            ]
          ],
          [
            [
              [120.01298747649187, 26.250724374679304],
              [120.01298747649187, 26.250724374679304]
            ]
          ],
          [
            [
              [119.99679804385718, 26.257039159134827],
              [119.99679804385718, 26.257039159134827]
            ]
          ],
          [
            [
              [119.99810327262671, 26.25602894007932],
              [119.99810327262671, 26.25602894007932]
            ]
          ],
          [
            [
              [119.99803654424365, 26.254575387282852],
              [119.99803654424365, 26.254575387282852]
            ]
          ],
          [
            [
              [119.98093475867665, 26.271042736876822],
              [119.98093475867665, 26.271042736876822]
            ]
          ],
          [
            [
              [119.986830809393, 26.276704364501633],
              [119.99788642960493, 26.28187571639663],
              [119.99797200974766, 26.281820648804967],
              [119.99347962457765, 26.26582028150821],
              [119.99342497951376, 26.265730213935743],
              [119.986830809393, 26.276704364501633]
            ]
          ],
          [
            [
              [120.01985131012842, 26.237889952960312],
              [120.01985131012842, 26.237889952960312]
            ]
          ],
          [
            [
              [120.01969187390782, 26.237883752237085],
              [120.01969187390782, 26.237883752237085]
            ]
          ],
          [
            [
              [119.99830955696912, 26.25554181567974],
              [119.99830955696912, 26.25554181567974]
            ]
          ],
          [
            [
              [119.99172467651674, 26.28379778069022],
              [119.99172467651674, 26.28379778069022]
            ]
          ],
          [
            [
              [120.02046247033054, 26.22689165330116],
              [120.02046247033054, 26.22689165330116]
            ]
          ],
          [
            [
              [120.01954159892131, 26.223928749341265],
              [120.01954159892131, 26.223928749341265]
            ]
          ],
          [
            [
              [120.0178928927473, 26.216409120244002],
              [120.0178928927473, 26.216409120244002]
            ]
          ],
          [
            [
              [120.01707216158555, 26.216596826433392],
              [120.01707216158555, 26.216596826433392]
            ]
          ],
          [
            [
              [120.0172036013189, 26.216881131356082],
              [120.0172036013189, 26.216881131356082]
            ]
          ],
          [
            [
              [120.01734583058892, 26.214208323832647],
              [120.01734583058892, 26.214208323832647]
            ]
          ],
          [
            [
              [120.01730124044961, 26.216749296959016],
              [120.01730124044961, 26.216749296959016]
            ]
          ],
          [
            [
              [120.01717339040421, 26.21628569921865],
              [120.01717339040421, 26.21628569921865]
            ]
          ],
          [
            [
              [120.01794741888479, 26.220762280856036],
              [120.01794741888479, 26.220762280856036]
            ]
          ],
          [
            [
              [120.02099095734252, 26.21294948789326],
              [120.02099095734252, 26.21294948789326]
            ]
          ],
          [
            [
              [120.01876116706103, 26.212728263897922],
              [120.01876116706103, 26.212728263897922]
            ]
          ],
          [
            [
              [120.01918778179731, 26.209902996845113],
              [120.01918778179731, 26.209902996845113]
            ]
          ],
          [
            [
              [120.01641846820134, 26.20914281482981],
              [120.01641846820134, 26.20914281482981]
            ]
          ],
          [
            [
              [120.01848553744209, 26.2083884202477],
              [120.01848553744209, 26.2083884202477]
            ]
          ],
          [
            [
              [120.01859566626025, 26.21266007251557],
              [120.01859566626025, 26.21266007251557]
            ]
          ],
          [
            [
              [120.02089180255066, 26.211966492883093],
              [120.02089180255066, 26.211966492883093]
            ]
          ],
          [
            [
              [120.02102386439014, 26.212593788086792],
              [120.02102386439014, 26.212593788086792]
            ]
          ],
          [
            [
              [119.98818835618243, 26.225405636242897],
              [119.98818835618243, 26.225405636242897]
            ]
          ],
          [
            [
              [119.9781477498413, 26.208082266625055],
              [119.9781477498413, 26.208082266625055]
            ]
          ],
          [
            [
              [119.97265880414422, 26.192461215368404],
              [119.97265880414422, 26.192461215368404]
            ]
          ],
          [
            [
              [119.9764488477776, 26.15968987714368],
              [119.9764488477776, 26.15968987714368]
            ]
          ],
          [
            [
              [119.97983184376285, 26.167473095339346],
              [119.97983184376285, 26.167473095339346]
            ]
          ],
          [
            [
              [119.97994649350413, 26.167384779465323],
              [119.97994649350413, 26.167384779465323]
            ]
          ],
          [
            [
              [119.97988589324373, 26.167423975624917],
              [119.97988589324373, 26.167423975624917]
            ]
          ],
          [
            [
              [119.97994128957336, 26.167361746231983],
              [119.97994128957336, 26.167361746231983]
            ]
          ],
          [
            [
              [119.9799692543786, 26.167466497210928],
              [119.9799692543786, 26.167466497210928]
            ]
          ],
          [
            [
              [119.97919330877708, 26.167870243231313],
              [119.97919330877708, 26.167870243231313]
            ]
          ],
          [
            [
              [119.97925898169566, 26.16794574678226],
              [119.97925898169566, 26.16794574678226]
            ]
          ],
          [
            [
              [119.97857782072833, 26.16762702380816],
              [119.97857782072833, 26.16762702380816]
            ]
          ],
          [
            [
              [119.97818005136946, 26.167519123438357],
              [119.97818005136946, 26.167519123438357]
            ]
          ],
          [
            [
              [119.97802735468754, 26.167458011377825],
              [119.97802735468754, 26.167458011377825]
            ]
          ],
          [
            [
              [119.97830685672788, 26.167606711200488],
              [119.97830685672788, 26.167606711200488]
            ]
          ],
          [
            [
              [119.9784958669559, 26.16692207656996],
              [119.9784958669559, 26.16692207656996]
            ]
          ],
          [
            [
              [119.97655101937082, 26.166531323217452],
              [119.97655101937082, 26.166531323217452]
            ]
          ],
          [
            [
              [119.97661950763337, 26.166854604620767],
              [119.97661950763337, 26.166854604620767]
            ]
          ],
          [
            [
              [119.97362176042216, 26.16719009315684],
              [119.97362176042216, 26.16719009315684]
            ]
          ],
          [
            [
              [119.97964650178923, 26.16493594236511],
              [119.97964650178923, 26.16493594236511]
            ]
          ],
          [
            [
              [119.97968900931768, 26.165047473858376],
              [119.97968900931768, 26.165047473858376]
            ]
          ],
          [
            [
              [119.97951825911142, 26.16498732463923],
              [119.97951825911142, 26.16498732463923]
            ]
          ],
          [
            [
              [119.97945490197945, 26.164336845523074],
              [119.97945490197945, 26.164336845523074]
            ]
          ],
          [
            [
              [119.97918489609947, 26.163715332328213],
              [119.97918489609947, 26.163715332328213]
            ]
          ],
          [
            [
              [119.97893496362578, 26.163757557047433],
              [119.97893496362578, 26.163757557047433]
            ]
          ],
          [
            [
              [119.97899060065141, 26.163769032763774],
              [119.97899060065141, 26.163769032763774]
            ]
          ],
          [
            [
              [119.97925365743747, 26.163702717230382],
              [119.97925365743747, 26.163702717230382]
            ]
          ],
          [
            [
              [119.97903992317018, 26.163825163048134],
              [119.97903992317018, 26.163825163048134]
            ]
          ],
          [
            [
              [119.97916554716738, 26.164079185808774],
              [119.97916554716738, 26.164079185808774]
            ]
          ],
          [
            [
              [119.97908681379144, 26.1640717534676],
              [119.97908681379144, 26.1640717534676]
            ]
          ],
          [
            [
              [119.97897767513315, 26.162519662485174],
              [119.97897767513315, 26.162519662485174]
            ]
          ],
          [
            [
              [119.9783263333251, 26.16608826321639],
              [119.9783263333251, 26.16608826321639]
            ]
          ],
          [
            [
              [119.97871223175024, 26.163695328241996],
              [119.97871223175024, 26.163695328241996]
            ]
          ],
          [
            [
              [119.97629070003306, 26.166255056383807],
              [119.97629070003306, 26.166255056383807]
            ]
          ],
          [
            [
              [119.97627235539193, 26.166167607650376],
              [119.97627235539193, 26.166167607650376]
            ]
          ],
          [
            [
              [119.97627376778865, 26.166207906608367],
              [119.97627376778865, 26.166207906608367]
            ]
          ],
          [
            [
              [119.97635435215112, 26.1663991709338],
              [119.97635435215112, 26.1663991709338]
            ]
          ],
          [
            [
              [119.97806034056785, 26.16313871430613],
              [119.97806034056785, 26.16313871430613]
            ]
          ],
          [
            [
              [119.97840813684455, 26.1622883427493],
              [119.97840813684455, 26.1622883427493]
            ]
          ],
          [
            [
              [119.9784201048478, 26.162153305267516],
              [119.9784201048478, 26.162153305267516]
            ]
          ],
          [
            [
              [119.97792162045229, 26.162326183626373],
              [119.97792162045229, 26.162326183626373]
            ]
          ],
          [
            [
              [119.97809225922714, 26.16239887790905],
              [119.97809225922714, 26.16239887790905]
            ]
          ],
          [
            [
              [119.97732074077345, 26.161935008091746],
              [119.97732074077345, 26.161935008091746]
            ]
          ],
          [
            [
              [119.97728547686535, 26.161861578730885],
              [119.97728547686535, 26.161861578730885]
            ]
          ],
          [
            [
              [119.97731266050668, 26.161714857978076],
              [119.97731266050668, 26.161714857978076]
            ]
          ],
          [
            [
              [119.97776698435156, 26.161869675994584],
              [119.97776698435156, 26.161869675994584]
            ]
          ],
          [
            [
              [119.97306459109413, 26.16644816524188],
              [119.97306459109413, 26.16644816524188]
            ]
          ],
          [
            [
              [119.97054162681664, 26.164401220602052],
              [119.97054162681664, 26.164401220602052]
            ]
          ],
          [
            [
              [119.9705417310698, 26.164211845695693],
              [119.9705417310698, 26.164211845695693]
            ]
          ],
          [
            [
              [119.97724484325208, 26.15972357122646],
              [119.97724484325208, 26.15972357122646]
            ]
          ],
          [
            [
              [119.9762813558151, 26.160151399620904],
              [119.9762813558151, 26.160151399620904]
            ]
          ],
          [
            [
              [119.97671852053331, 26.160261422028995],
              [119.97671852053331, 26.160261422028995]
            ]
          ],
          [
            [
              [119.97679477172201, 26.16023417261506],
              [119.97679477172201, 26.16023417261506]
            ]
          ],
          [
            [
              [119.97695862143216, 26.15958777363267],
              [119.97695862143216, 26.15958777363267]
            ]
          ],
          [
            [
              [119.97669294863633, 26.159513034062606],
              [119.97669294863633, 26.159513034062606]
            ]
          ],
          [
            [
              [119.97631203903609, 26.15951687543291],
              [119.97631203903609, 26.15951687543291]
            ]
          ],
          [
            [
              [119.97685499500548, 26.1596115311623],
              [119.97685499500548, 26.1596115311623]
            ]
          ],
          [
            [
              [119.97666455581184, 26.159617421498016],
              [119.97666455581184, 26.159617421498016]
            ]
          ],
          [
            [
              [119.97554870351179, 26.160082599281452],
              [119.97554870351179, 26.160082599281452]
            ]
          ],
          [
            [
              [119.97555164058853, 26.15995180894309],
              [119.97555164058853, 26.15995180894309]
            ]
          ],
          [
            [
              [119.97579454127944, 26.160165556107536],
              [119.97579454127944, 26.160165556107536]
            ]
          ],
          [
            [
              [119.97802791122174, 26.160337284176833],
              [119.97802791122174, 26.160337284176833]
            ]
          ],
          [
            [
              [119.97852505255204, 26.162233903858343],
              [119.97852505255204, 26.162233903858343]
            ]
          ],
          [
            [
              [119.97894975529533, 26.165908412903338],
              [119.97894975529533, 26.165908412903338]
            ]
          ],
          [
            [
              [119.978392196167, 26.163629390032266],
              [119.978392196167, 26.163629390032266]
            ]
          ],
          [
            [
              [119.9659200893546, 26.156001461708506],
              [119.9659200893546, 26.156001461708506]
            ]
          ],
          [
            [
              [119.96505614699439, 26.155518318090923],
              [119.96505614699439, 26.155518318090923]
            ]
          ],
          [
            [
              [119.96467861987531, 26.155728889238762],
              [119.96467861987531, 26.155728889238762]
            ]
          ],
          [
            [
              [119.96486758968598, 26.155788275134256],
              [119.96486758968598, 26.155788275134256]
            ]
          ],
          [
            [
              [119.96489182076839, 26.155450258197597],
              [119.96489182076839, 26.155450258197597]
            ]
          ],
          [
            [
              [119.96480331600678, 26.15549286655955],
              [119.96480331600678, 26.15549286655955]
            ]
          ],
          [
            [
              [119.96475985455223, 26.155613758118914],
              [119.96475985455223, 26.155613758118914]
            ]
          ],
          [
            [
              [119.96490537577236, 26.15587487334427],
              [119.96490537577236, 26.15587487334427]
            ]
          ],
          [
            [
              [119.96502492967059, 26.155465777738648],
              [119.96502492967059, 26.155465777738648]
            ]
          ],
          [
            [
              [119.96491425213183, 26.15561088421595],
              [119.96491425213183, 26.15561088421595]
            ]
          ],
          [
            [
              [119.96114357040334, 26.14880351427721],
              [119.96114357040334, 26.14880351427721]
            ]
          ],
          [
            [
              [119.96112315073879, 26.149161527013117],
              [119.96112315073879, 26.149161527013117]
            ]
          ],
          [
            [
              [119.96055311762647, 26.149127137745936],
              [119.96055311762647, 26.149127137745936]
            ]
          ],
          [
            [
              [119.96115389602673, 26.149487583477672],
              [119.96115389602673, 26.149487583477672]
            ]
          ],
          [
            [
              [119.95128456890272, 26.144859215960683],
              [119.95128456890272, 26.144859215960683]
            ]
          ],
          [
            [
              [119.95119921241003, 26.14500514509912],
              [119.95119921241003, 26.14500514509912]
            ]
          ],
          [
            [
              [119.93406274751351, 26.168495231709997],
              [119.93406274751351, 26.168495231709997]
            ]
          ],
          [
            [
              [119.93671728796942, 26.16081010143559],
              [119.93671728796942, 26.16081010143559]
            ]
          ],
          [
            [
              [119.92574134009455, 26.173312419825418],
              [119.92574134009455, 26.173312419825418]
            ]
          ],
          [
            [
              [119.92952396421332, 26.13678476750317],
              [119.92952396421332, 26.13678476750317]
            ]
          ],
          [
            [
              [119.9780351649841, 26.16754040056348],
              [119.9780351649841, 26.16754040056348]
            ]
          ],
          [
            [
              [119.97665871349763, 26.166717288149258],
              [119.97665871349763, 26.166717288149258]
            ]
          ],
          [
            [
              [119.97830522321128, 26.163403299281747],
              [119.97830522321128, 26.163403299281747]
            ]
          ],
          [
            [
              [119.97753207192353, 26.161958816774337],
              [119.97753207192353, 26.161958816774337]
            ]
          ],
          [
            [
              [119.97791437952161, 26.16162252638311],
              [119.97791437952161, 26.16162252638311]
            ]
          ],
          [
            [
              [119.9779901760522, 26.161781184123964],
              [119.9779901760522, 26.161781184123964]
            ]
          ],
          [
            [
              [119.97733490104957, 26.161851440961804],
              [119.97733490104957, 26.161851440961804]
            ]
          ],
          [
            [
              [119.97763611365967, 26.161833552042122],
              [119.97763611365967, 26.161833552042122]
            ]
          ],
          [
            [
              [119.97886600656332, 26.163716404944758],
              [119.97886600656332, 26.163716404944758]
            ]
          ],
          [
            [
              [119.96326689235228, 26.167132783721556],
              [119.96326689235228, 26.167132783721556]
            ]
          ],
          [
            [
              [120.50448549789363, 26.361520525524114],
              [120.50448549789363, 26.361520525524114]
            ]
          ],
          [
            [
              [120.503047622274, 26.360561749645154],
              [120.503047622274, 26.360561749645154]
            ]
          ],
          [
            [
              [120.5003917819725, 26.35677294928953],
              [120.5003917819725, 26.35677294928953]
            ]
          ],
          [
            [
              [120.50087241300126, 26.357777333898625],
              [120.50087241300126, 26.357777333898625]
            ]
          ],
          [
            [
              [120.49961879223251, 26.355545294109252],
              [120.49961879223251, 26.355545294109252]
            ]
          ],
          [
            [
              [120.4890372482241, 26.352347928269822],
              [120.4890372482241, 26.352347928269822]
            ]
          ],
          [
            [
              [120.48923452375449, 26.35270134445528],
              [120.48923452375449, 26.35270134445528]
            ]
          ],
          [
            [
              [120.49170621520047, 26.35380126133962],
              [120.49170621520047, 26.35380126133962]
            ]
          ],
          [
            [
              [120.48761262345218, 26.35142270054049],
              [120.48761262345218, 26.35142270054049]
            ]
          ],
          [
            [
              [120.48634789303756, 26.382314625902755],
              [120.48634789303756, 26.382314625902755]
            ]
          ],
          [
            [
              [120.4800322402264, 26.382192580354033],
              [120.4800322402264, 26.382192580354033]
            ]
          ],
          [
            [
              [120.47964646576787, 26.381970785841048],
              [120.47964646576787, 26.381970785841048]
            ]
          ],
          [
            [
              [120.47964071983333, 26.381778999625073],
              [120.47964071983333, 26.381778999625073]
            ]
          ],
          [
            [
              [120.47965652263228, 26.381666777248],
              [120.47965652263228, 26.381666777248]
            ]
          ],
          [
            [
              [120.49163123876403, 26.354695846637668],
              [120.49163123876403, 26.354695846637668]
            ]
          ],
          [
            [
              [120.50301506259612, 26.35998555885631],
              [120.49003269685494, 26.35415762486372],
              [120.48992341432664, 26.35417211144042],
              [120.48265777144144, 26.377360113630353],
              [120.48264966108822, 26.377380153644378],
              [120.47491849410382, 26.370608456517015],
              [120.47489780377714, 26.370699016503053],
              [120.50534913449066, 26.37657249204329],
              [120.50545471913834, 26.376537068736855],
              [120.51707929850008, 26.364326517606578],
              [120.5170691224341, 26.36422512530628],
              [120.50301506259612, 26.35998555885631]
            ]
          ],
          [
            [
              [120.48035832927667, 26.381677976924895],
              [120.48035832927667, 26.381677976924895]
            ]
          ],
          [
            [
              [120.48777459770662, 26.351571391693398],
              [120.48777459770662, 26.351571391693398]
            ]
          ],
          [
            [
              [119.94593960146568, 25.980866754601994],
              [119.94593960146568, 25.980866754601994]
            ]
          ],
          [
            [
              [119.95005231869855, 25.981340201018128],
              [119.95005231869855, 25.981340201018128]
            ]
          ],
          [
            [
              [119.99751269919729, 25.981353508293406],
              [119.99751269919729, 25.981353508293406]
            ]
          ],
          [
            [
              [119.99793252699631, 25.980376259389967],
              [119.99793252699631, 25.980376259389967]
            ]
          ],
          [
            [
              [119.99782479522135, 25.98067834816763],
              [119.99782479522135, 25.98067834816763]
            ]
          ],
          [
            [
              [119.9981306359716, 25.979899473493447],
              [119.9981306359716, 25.979899473493447]
            ]
          ],
          [
            [
              [119.9981229969604, 25.979819020090936],
              [119.9981229969604, 25.979819020090936]
            ]
          ],
          [
            [
              [119.99733555827751, 25.980122744334896],
              [119.99733555827751, 25.980122744334896]
            ]
          ],
          [
            [
              [119.99708608308876, 25.97924385575933],
              [119.99708608308876, 25.97924385575933]
            ]
          ],
          [
            [
              [119.99708762829478, 25.979230786891478],
              [119.99708762829478, 25.979230786891478]
            ]
          ],
          [
            [
              [119.99761702057545, 25.98023539815273],
              [119.99761702057545, 25.98023539815273]
            ]
          ],
          [
            [
              [119.99555910106344, 25.975897127245457],
              [119.99555910106344, 25.975897127245457]
            ]
          ],
          [
            [
              [119.99553520032227, 25.975896902063237],
              [119.99553520032227, 25.975896902063237]
            ]
          ],
          [
            [
              [119.99476881496011, 25.96946873677136],
              [119.99476881496011, 25.96946873677136]
            ]
          ],
          [
            [
              [119.99477655559691, 25.969626327593353],
              [119.99477655559691, 25.969626327593353]
            ]
          ],
          [
            [
              [119.99474684868822, 25.96841333559791],
              [119.99474684868822, 25.96841333559791]
            ]
          ],
          [
            [
              [119.99139808722894, 25.964665249163573],
              [119.99139808722894, 25.964665249163573]
            ]
          ],
          [
            [
              [119.99139524353707, 25.964008903147597],
              [119.99139524353707, 25.964008903147597]
            ]
          ],
          [
            [
              [119.99033336887507, 25.963021207197386],
              [119.99033336887507, 25.963021207197386]
            ]
          ],
          [
            [
              [119.99005288880127, 25.9631359633274],
              [119.99005288880127, 25.9631359633274]
            ]
          ],
          [
            [
              [119.99001717606941, 25.9630777438398],
              [119.99001717606941, 25.9630777438398]
            ]
          ],
          [
            [
              [119.99089483787738, 25.963588111563695],
              [119.99089483787738, 25.963588111563695]
            ]
          ],
          [
            [
              [119.98114594121658, 25.974836754494664],
              [119.98114594121658, 25.974836754494664]
            ]
          ],
          [
            [
              [119.9813621838126, 25.974756272186106],
              [119.9813621838126, 25.974756272186106]
            ]
          ],
          [
            [
              [119.97118827151094, 25.97431389475431],
              [119.97118827151094, 25.97431389475431]
            ]
          ],
          [
            [
              [119.97128565144529, 25.974625816746645],
              [119.97128565144529, 25.974625816746645]
            ]
          ],
          [
            [
              [119.97136478159719, 25.973933760792143],
              [119.97136478159719, 25.973933760792143]
            ]
          ],
          [
            [
              [119.97156199830735, 25.973499246909487],
              [119.97156199830735, 25.973499246909487]
            ]
          ],
          [
            [
              [119.97177726856789, 25.973935817352643],
              [119.97177726856789, 25.973935817352643]
            ]
          ],
          [
            [
              [119.97174662306749, 25.973844692850278],
              [119.97174662306749, 25.973844692850278]
            ]
          ],
          [
            [
              [119.97004301052426, 25.97125540219723],
              [119.97004301052426, 25.97125540219723]
            ]
          ],
          [
            [
              [119.97035602286478, 25.97286727317178],
              [119.97035602286478, 25.97286727317178]
            ]
          ],
          [
            [
              [119.9724601650554, 25.97018424435999],
              [119.9724601650554, 25.97018424435999]
            ]
          ],
          [
            [
              [119.97158778027506, 25.973905843593435],
              [119.97158778027506, 25.973905843593435]
            ]
          ],
          [
            [
              [119.98209196831384, 25.973768548353565],
              [119.98209196831384, 25.973768548353565]
            ]
          ],
          [
            [
              [119.98344189317982, 25.958201342174537],
              [119.98344189317982, 25.958201342174537]
            ]
          ],
          [
            [
              [119.98443240747804, 25.95547253568003],
              [119.98443240747804, 25.95547253568003]
            ]
          ],
          [
            [
              [119.98392113046869, 25.957041194532977],
              [119.98392113046869, 25.957041194532977]
            ]
          ],
          [
            [
              [119.9706513542926, 25.94846438284618],
              [119.9706513542926, 25.94846438284618]
            ]
          ],
          [
            [
              [119.96957870156966, 25.94547356721487],
              [119.96957870156966, 25.94547356721487]
            ]
          ],
          [
            [
              [119.96789568246703, 25.944865124673886],
              [119.96789568246703, 25.944865124673886]
            ]
          ],
          [
            [
              [119.98217063692223, 25.972658954119186],
              [119.9938864461966, 25.966117025396585],
              [119.99387403425922, 25.96609152482662],
              [119.96574439191826, 25.94877503095783],
              [119.96574010612386, 25.94882744835954],
              [119.98217063692223, 25.972658954119186]
            ]
          ],
          [
            [
              [119.95353870735303, 25.98025250830854],
              [119.95353870735303, 25.98025250830854]
            ]
          ],
          [
            [
              [119.95345032066606, 25.979998355792155],
              [119.95345032066606, 25.979998355792155]
            ]
          ],
          [
            [
              [119.95346204757882, 25.979851954254553],
              [119.95346204757882, 25.979851954254553]
            ]
          ],
          [
            [
              [119.95164633791715, 25.980701097863598],
              [119.95164633791715, 25.980701097863598]
            ]
          ],
          [
            [
              [119.95157339020427, 25.98093432938655],
              [119.95157339020427, 25.98093432938655]
            ]
          ],
          [
            [
              [119.95020066579998, 25.981003384725103],
              [119.95020066579998, 25.981003384725103]
            ]
          ],
          [
            [
              [119.95158090603347, 25.98060427456459],
              [119.95158090603347, 25.98060427456459]
            ]
          ],
          [
            [
              [119.95241509135052, 25.976331866632947],
              [119.95241509135052, 25.976331866632947]
            ]
          ],
          [
            [
              [119.95220205993368, 25.975804046866696],
              [119.95220205993368, 25.975804046866696]
            ]
          ],
          [
            [
              [119.95219217554305, 25.975891540196372],
              [119.95219217554305, 25.975891540196372]
            ]
          ],
          [
            [
              [119.94593960146568, 25.980866754601994],
              [119.94593960146568, 25.980866754601994]
            ]
          ],
          [
            [
              [119.94904148193349, 25.981190492901746],
              [119.94904148193349, 25.981190492901746]
            ]
          ],
          [
            [
              [119.94987469481991, 25.98165104510527],
              [119.94987469481991, 25.98165104510527]
            ]
          ],
          [
            [
              [119.92462719102795, 25.97326739982505],
              [119.92462719102795, 25.97326739982505]
            ]
          ],
          [
            [
              [119.98193387267854, 25.974891784206246],
              [119.98193387267854, 25.974891784206246]
            ]
          ],
          [
            [
              [119.97233124643256, 25.974033298735552],
              [119.97233124643256, 25.974033298735552]
            ]
          ],
          [
            [
              [119.9728630791499, 25.97302745656374],
              [119.9728630791499, 25.97302745656374]
            ]
          ],
          [
            [
              [119.9717960965373, 25.973613245772775],
              [119.9717960965373, 25.973613245772775]
            ]
          ],
          [
            [
              [119.97126038616237, 25.973897928060623],
              [119.97126038616237, 25.973897928060623]
            ]
          ],
          [
            [
              [119.9707694976975, 25.973067440371562],
              [119.9707694976975, 25.973067440371562]
            ]
          ],
          [
            [
              [119.9321118729428, 25.98022305272012],
              [119.9321118729428, 25.98022305272012]
            ]
          ],
          [
            [
              [120.23441906473342, 26.345685209469547],
              [120.23441906473342, 26.345685209469547]
            ]
          ],
          [
            [
              [120.23491733076054, 26.345656061492377],
              [120.23491733076054, 26.345656061492377]
            ]
          ],
          [
            [
              [120.23249871432023, 26.341200571079497],
              [120.23249871432023, 26.341200571079497]
            ]
          ],
          [
            [
              [120.23074132900508, 26.33970332924197],
              [120.23074132900508, 26.33970332924197]
            ]
          ],
          [
            [
              [120.23108828014229, 26.340502727989005],
              [120.23108828014229, 26.340502727989005]
            ]
          ],
          [
            [
              [120.23024009273992, 26.338950086175],
              [120.23024009273992, 26.338950086175]
            ]
          ],
          [
            [
              [120.229692721537, 26.338005926870405],
              [120.229692721537, 26.338005926870405]
            ]
          ],
          [
            [
              [120.22865643303967, 26.337498588116333],
              [120.22865643303967, 26.337498588116333]
            ]
          ],
          [
            [
              [120.22854688383556, 26.337519902910483],
              [120.22854688383556, 26.337519902910483]
            ]
          ],
          [
            [
              [120.23306604969228, 26.342137589407262],
              [120.23306604969228, 26.342137589407262]
            ]
          ],
          [
            [
              [120.2223269745641, 26.33437192980682],
              [120.2223269745641, 26.33437192980682]
            ]
          ],
          [
            [
              [120.22244388839393, 26.334610231984875],
              [120.22244388839393, 26.334610231984875]
            ]
          ],
          [
            [
              [120.22189388818535, 26.333303919023184],
              [120.22189388818535, 26.333303919023184]
            ]
          ],
          [
            [
              [120.21984291988935, 26.334002626683166],
              [120.21984291988935, 26.334002626683166]
            ]
          ],
          [
            [
              [120.22154302847406, 26.33328621421059],
              [120.22154302847406, 26.33328621421059]
            ]
          ],
          [
            [
              [120.21926018551936, 26.33349888080208],
              [120.21926018551936, 26.33349888080208]
            ]
          ],
          [
            [
              [120.21900921961677, 26.3336509414373],
              [120.21900921961677, 26.3336509414373]
            ]
          ],
          [
            [
              [120.21925500321906, 26.333474371462877],
              [120.21925500321906, 26.333474371462877]
            ]
          ],
          [
            [
              [120.21943648611858, 26.33359350264484],
              [120.21943648611858, 26.33359350264484]
            ]
          ],
          [
            [
              [120.2323908010863, 26.344044660418298],
              [120.2323908010863, 26.344044660418298]
            ]
          ],
          [
            [
              [120.23431233823626, 26.343559957866592],
              [120.22362813971141, 26.33453389634859],
              [120.22361990826263, 26.334724686905833],
              [120.23431233823626, 26.343559957866592]
            ]
          ],
          [
            [
              [120.00337013958125, 26.28043117690528],
              [120.00337013958125, 26.28043117690528]
            ]
          ],
          [
            [
              [120.00455386683262, 26.27899531087665],
              [120.00455386683262, 26.27899531087665]
            ]
          ],
          [
            [
              [120.00432350107263, 26.27920133510304],
              [120.00432350107263, 26.27920133510304]
            ]
          ],
          [
            [
              [120.00472361180537, 26.281418151374815],
              [120.00472361180537, 26.281418151374815]
            ]
          ],
          [
            [
              [120.00482253043978, 26.281291663121678],
              [120.00482253043978, 26.281291663121678]
            ]
          ],
          [
            [
              [120.00467929765396, 26.281391656039393],
              [120.00467929765396, 26.281391656039393]
            ]
          ],
          [
            [
              [120.00364295818534, 26.280898640482096],
              [120.00364295818534, 26.280898640482096]
            ]
          ],
          [
            [
              [120.01398697519514, 26.29692970278006],
              [120.01398697519514, 26.29692970278006]
            ]
          ],
          [
            [
              [120.01418705083384, 26.297204797036496],
              [120.01418705083384, 26.297204797036496]
            ]
          ],
          [
            [
              [119.95395087480553, 26.194435925023715],
              [119.95395087480553, 26.194435925023715]
            ]
          ],
          [
            [
              [119.9861454613438, 26.185387819482887],
              [119.9861454613438, 26.185387819482887]
            ]
          ],
          [
            [
              [119.98600976701495, 26.186306102933017],
              [119.98600976701495, 26.186306102933017]
            ]
          ],
          [
            [
              [119.98590213035256, 26.185432943926617],
              [119.98590213035256, 26.185432943926617]
            ]
          ],
          [
            [
              [119.96968265730756, 26.142897584858645],
              [119.96968265730756, 26.142897584858645]
            ]
          ],
          [
            [
              [119.96987205813507, 26.143315899916818],
              [119.96987205813507, 26.143315899916818]
            ]
          ],
          [
            [
              [119.97051732813335, 26.143282249515533],
              [119.97051732813335, 26.143282249515533]
            ]
          ],
          [
            [
              [119.97041057750633, 26.143341658215355],
              [119.97041057750633, 26.143341658215355]
            ]
          ],
          [
            [
              [119.96974149784944, 26.143141317179182],
              [119.96974149784944, 26.143141317179182]
            ]
          ],
          [
            [
              [119.96993763748583, 26.142909091242096],
              [119.96993763748583, 26.142909091242096]
            ]
          ],
          [
            [
              [119.97773919981177, 26.11460437196656],
              [119.97773919981177, 26.11460437196656]
            ]
          ],
          [
            [
              [119.9777614993371, 26.114869338769775],
              [119.9777614993371, 26.114869338769775]
            ]
          ],
          [
            [
              [119.97957258510881, 26.114191674391105],
              [119.97957258510881, 26.114191674391105]
            ]
          ],
          [
            [
              [119.97076627009386, 26.09025740556886],
              [119.97076627009386, 26.09025740556886]
            ]
          ],
          [
            [
              [119.97054623980934, 26.09030787480546],
              [119.97054623980934, 26.09030787480546]
            ]
          ],
          [
            [
              [119.97116450541066, 26.09028463261889],
              [119.97116450541066, 26.09028463261889]
            ]
          ],
          [
            [
              [119.97065541094734, 26.089831506551555],
              [119.97065541094734, 26.089831506551555]
            ]
          ],
          [
            [
              [119.96891784850816, 26.084059042773248],
              [119.96891784850816, 26.084059042773248]
            ]
          ],
          [
            [
              [119.9682710150427, 26.08451321910896],
              [119.9682710150427, 26.08451321910896]
            ]
          ],
          [
            [
              [119.96813980405152, 26.084749691257453],
              [119.96813980405152, 26.084749691257453]
            ]
          ],
          [
            [
              [119.96795818135338, 26.08463903972873],
              [119.96795818135338, 26.08463903972873]
            ]
          ],
          [
            [
              [119.96758362627514, 26.08360029263547],
              [119.96758362627514, 26.08360029263547]
            ]
          ],
          [
            [
              [119.96813360045643, 26.083833801603255],
              [119.96813360045643, 26.083833801603255]
            ]
          ],
          [
            [
              [119.96688855684093, 26.08566112936198],
              [119.96688855684093, 26.08566112936198]
            ]
          ],
          [
            [
              [119.96671483552106, 26.085681675603585],
              [119.96671483552106, 26.085681675603585]
            ]
          ],
          [
            [
              [119.96678847550902, 26.085416348755427],
              [119.96678847550902, 26.085416348755427]
            ]
          ],
          [
            [
              [119.96681143458481, 26.08560191141547],
              [119.96681143458481, 26.08560191141547]
            ]
          ],
          [
            [
              [119.96738293876496, 26.0835021235701],
              [119.96738293876496, 26.0835021235701]
            ]
          ],
          [
            [
              [119.9673877505883, 26.084707923589466],
              [119.9673877505883, 26.084707923589466]
            ]
          ],
          [
            [
              [120.48847219634106, 26.387795116153768],
              [120.48847219634106, 26.387795116153768]
            ]
          ],
          [
            [
              [120.4082593437867, 26.156136898617547],
              [120.4082593437867, 26.156136898617547]
            ]
          ],
          [
            [
              [120.20811755429675, 26.246662347802744],
              [120.20811755429675, 26.246662347802744]
            ]
          ],
          [
            [
              [120.20809521585218, 26.246847051862993],
              [120.20809521585218, 26.246847051862993]
            ]
          ],
          [
            [
              [120.06681837080967, 26.23649321138815],
              [120.06681837080967, 26.23649321138815]
            ]
          ],
          [
            [
              [120.06693933371766, 26.235765653457033],
              [120.06693933371766, 26.235765653457033]
            ]
          ],
          [
            [
              [120.06738124936425, 26.235967020850822],
              [120.06738124936425, 26.235967020850822]
            ]
          ],
          [
            [
              [120.06752196929264, 26.23601569965985],
              [120.06752196929264, 26.23601569965985]
            ]
          ],
          [
            [
              [120.06651776093967, 26.235516035068933],
              [120.06651776093967, 26.235516035068933]
            ]
          ],
          [
            [
              [120.06663512176071, 26.235806900961133],
              [120.06663512176071, 26.235806900961133]
            ]
          ],
          [
            [
              [120.06595573304755, 26.236090018063226],
              [120.06595573304755, 26.236090018063226]
            ]
          ],
          [
            [
              [120.06589352366345, 26.23559056641671],
              [120.06589352366345, 26.23559056641671]
            ]
          ],
          [
            [
              [120.0678030225625, 26.232364995606225],
              [120.0678030225625, 26.232364995606225]
            ]
          ],
          [
            [
              [120.05412008454834, 26.225066961044284],
              [120.05412008454834, 26.225066961044284]
            ]
          ],
          [
            [
              [119.97740460828437, 26.198734352143017],
              [119.97298811313324, 26.219937343707585],
              [119.97300376429725, 26.219949063279213],
              [120.00082240852888, 26.23687207583684],
              [120.00084278174491, 26.236879317393118],
              [120.02086601493487, 26.226431063672774],
              [120.02089095073754, 26.226405096551943],
              [119.97740460828437, 26.198734352143017]
            ]
          ],
          [
            [
              [119.9349193578392, 25.969643148530402],
              [119.93090587088105, 25.97992953202398],
              [119.93094667288155, 25.979956762188607],
              [119.95404486152518, 25.977807425333665],
              [119.95404524600696, 25.977798846147735],
              [119.9349193578392, 25.969643148530402]
            ]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10008001", "COUNTYNAME": "南投县", "name": "南投县" },
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [121.23767464362308, 24.22019862349567],
            [121.26374688077547, 24.246259970910526],
            [121.26461380398298, 24.246281038872212],
            [121.27952908130905, 24.23040652769458],
            [121.27980182734987, 24.230227717341187],
            [121.33446222788197, 24.229549860178107],
            [121.33520307775494, 24.229166674703443],
            [121.34936724633391, 24.201949743355392],
            [121.34943161941818, 24.20107592764084],
            [121.28678129712101, 24.177635505361806],
            [121.28634357421167, 24.177512175167525],
            [121.28043810499, 24.157976197440018],
            [121.28034971457397, 24.157779863820004],
            [121.28132922952923, 24.135751384348687],
            [121.28134588009148, 24.135633954122046],
            [121.32843073934269, 24.11454547483456],
            [121.32847873130903, 24.114317272380884],
            [121.32322554926596, 24.085180153218868],
            [121.32316230181189, 24.084920764400874],
            [121.28351156033402, 24.054685323758353],
            [121.2833234732967, 24.054457579328933],
            [121.26020951709773, 23.992490955211665],
            [121.26011515655144, 23.99214798431056],
            [121.277876746113, 23.96583598422776],
            [121.27790767767428, 23.965655328261647],
            [121.26522908840968, 23.873152570443132],
            [121.26526759493288, 23.87292450513365],
            [121.23965001189814, 23.84084995625457],
            [121.23936864599578, 23.84032441282146],
            [121.23058223154774, 23.789358265770577],
            [121.23046588870672, 23.788071786655127],
            [121.20467610091171, 23.772407613076577],
            [121.2046343088964, 23.772348974716337],
            [121.23281703364755, 23.74996264401126],
            [121.2332409507067, 23.7491605269529],
            [121.23584587476553, 23.662664516484032],
            [121.23561592489105, 23.66170769452972],
            [121.21358282457642, 23.600622828457887],
            [121.21334941123843, 23.60037708172897],
            [121.1534045088663, 23.586810351551236],
            [121.15332138631885, 23.58668618025963],
            [121.15111158358943, 23.527044701065012],
            [121.15097636673214, 23.526559463870694],
            [121.13529315913812, 23.514990496875235],
            [121.13504427893955, 23.514904926688466],
            [121.06851861785249, 23.51847058598193],
            [121.06844606359572, 23.51842329997699],
            [121.0392050523052, 23.474386710349236],
            [121.03912224606455, 23.47420396008855],
            [121.05895451918262, 23.461925370683876],
            [121.05909390531329, 23.46168593628625],
            [121.05207853521529, 23.451197481062522],
            [121.05174681665827, 23.45083412520189],
            [121.01539001963582, 23.43526268059949],
            [121.01513112044917, 23.43519497912711],
            [121.00841756419956, 23.462027046461138],
            [121.0081240680715, 23.46236560444601],
            [120.9809411926358, 23.46903585768732],
            [120.98012176372953, 23.469211844251447],
            [120.839162786263, 23.471133601093477],
            [120.83826882813767, 23.47144205019223],
            [120.80871669938118, 23.535905274378802],
            [120.80861276999188, 23.53602480426703],
            [120.81809230107821, 23.599132863682954],
            [120.81758612386628, 23.599592827853115],
            [120.73124885887022, 23.61074114820878],
            [120.73085992600784, 23.61076304932888],
            [120.7188662424427, 23.629582157378064],
            [120.71854133111786, 23.6299293202005],
            [120.68372200397802, 23.610782774291042],
            [120.68354296275015, 23.610676226364422],
            [120.66138306319958, 23.610236074844217],
            [120.66103782926913, 23.61039785108432],
            [120.64685232454899, 23.630906564039147],
            [120.64651421300381, 23.631126945131907],
            [120.63342572243964, 23.6194350814175],
            [120.633139539681, 23.619596934314742],
            [120.64797758111115, 23.682484859672087],
            [120.64807405697128, 23.682789853865764],
            [120.63970928773416, 23.728489283528685],
            [120.63970736392392, 23.729189194936776],
            [120.6558198031921, 23.735083502581844],
            [120.65584806340898, 23.73541093104863],
            [120.64044848158551, 23.785708805242706],
            [120.6403502196714, 23.786038160718185],
            [120.68391440161341, 23.803084695660655],
            [120.68389427448909, 23.803355545904232],
            [120.67655877491363, 23.81903558145719],
            [120.67633749197928, 23.81922474976333],
            [120.65150508814108, 23.81244288685124],
            [120.65089462531998, 23.81250245674939],
            [120.61554880089606, 23.840367016335783],
            [120.61554828812109, 23.840540925688735],
            [120.63496932206947, 23.898495801179433],
            [120.63499401910437, 23.8986087475135],
            [120.62680410734976, 23.955682987085346],
            [120.6268362276461, 23.9564190146073],
            [120.64126236817684, 23.95708570690473],
            [120.64221137581967, 23.9579658965901],
            [120.65014197348698, 23.98351621014724],
            [120.65019494948214, 23.983800678432047],
            [120.63822829103064, 24.004393088081926],
            [120.6380393257197, 24.007438112997562],
            [120.67866422186995, 24.014030719026568],
            [120.67877310569023, 24.014213830077534],
            [120.74590526764969, 23.99854506520877],
            [120.74599138832089, 23.998486416684514],
            [120.82927615722159, 24.071412468875245],
            [120.82933237419938, 24.071430590531314],
            [120.84450255605829, 24.12403619223313],
            [120.84484755133373, 24.12451970676172],
            [120.87904509521682, 24.10937418111034],
            [120.87915587810265, 24.10925471902629],
            [120.87803642981996, 24.085025323161812],
            [120.87808672157152, 24.084984730672655],
            [120.89114616304856, 24.11568569018627],
            [120.8915353413831, 24.115900515276817],
            [120.9194107013899, 24.10737128802556],
            [120.91973559492813, 24.107432407767767],
            [120.94973064105119, 24.127827195011644],
            [120.94989435471588, 24.12784991266722],
            [120.98890797986998, 24.118695021952735],
            [120.98904125699676, 24.118710923382565],
            [121.01888940876114, 24.159232659696062],
            [121.01939784241114, 24.159591514147515],
            [121.05217498888882, 24.15554768902735],
            [121.05235829785184, 24.155592773200958],
            [121.16737822882628, 24.225818648745594],
            [121.16748669565301, 24.225931395542656],
            [121.18093080787334, 24.212715617296794],
            [121.18130578082135, 24.21263842241787],
            [121.21929445222261, 24.229674110432313],
            [121.21951975093323, 24.229721189370725],
            [121.23767464362308, 24.22019862349567]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10016001", "COUNTYNAME": "澎湖县", "name": "澎湖县" },
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [119.4160650757999, 23.19321917707155],
              [119.4160650757999, 23.19321917707155]
            ]
          ],
          [
            [
              [119.42006813471875, 23.203943353331663],
              [119.41020841715324, 23.216731406014897],
              [119.41029734663624, 23.21683727792708],
              [119.44781608506318, 23.22023107756047],
              [119.44795795885939, 23.220111025396267],
              [119.43046350629156, 23.186632906128366],
              [119.43042949109301, 23.186590105897956],
              [119.42006813471875, 23.203943353331663]
            ]
          ],
          [
            [
              [119.59921751853176, 23.79349457121557],
              [119.59921751853176, 23.79349457121557]
            ]
          ],
          [
            [
              [119.59759987318273, 23.795250035373805],
              [119.59759987318273, 23.795250035373805]
            ]
          ],
          [
            [
              [119.59871353572404, 23.792988758810623],
              [119.59871353572404, 23.792988758810623]
            ]
          ],
          [
            [
              [119.59839698243704, 23.79219033952449],
              [119.59839698243704, 23.79219033952449]
            ]
          ],
          [
            [
              [119.60160835155517, 23.78702390509311],
              [119.60160835155517, 23.78702390509311]
            ]
          ],
          [
            [
              [119.59973757615327, 23.783530810080315],
              [119.59973757615327, 23.783530810080315]
            ]
          ],
          [
            [
              [119.6033984583097, 23.786404439468424],
              [119.6033984583097, 23.786404439468424]
            ]
          ],
          [
            [
              [119.60295000587395, 23.78584862595254],
              [119.60295000587395, 23.78584862595254]
            ]
          ],
          [
            [
              [119.60233171200116, 23.784912583324605],
              [119.60233171200116, 23.784912583324605]
            ]
          ],
          [
            [
              [119.60783057744258, 23.781796834148263],
              [119.60783057744258, 23.781796834148263]
            ]
          ],
          [
            [
              [119.60535068322106, 23.78298566118757],
              [119.60535068322106, 23.78298566118757]
            ]
          ],
          [
            [
              [119.60448056812942, 23.782167528684546],
              [119.60448056812942, 23.782167528684546]
            ]
          ],
          [
            [
              [119.60550415091978, 23.781969249863337],
              [119.60550415091978, 23.781969249863337]
            ]
          ],
          [
            [
              [119.6069270149687, 23.781789238530163],
              [119.6069270149687, 23.781789238530163]
            ]
          ],
          [
            [
              [119.60629248886602, 23.78032223772958],
              [119.60629248886602, 23.78032223772958]
            ]
          ],
          [
            [
              [119.60414288380167, 23.78140360324972],
              [119.60414288380167, 23.78140360324972]
            ]
          ],
          [
            [
              [119.60714646547723, 23.779354934662795],
              [119.60714646547723, 23.779354934662795]
            ]
          ],
          [
            [
              [119.60928527362316, 23.77892143380122],
              [119.60928527362316, 23.77892143380122]
            ]
          ],
          [
            [
              [119.61099400271955, 23.777763143592136],
              [119.61099400271955, 23.777763143592136]
            ]
          ],
          [
            [
              [119.60793790061568, 23.779378764292023],
              [119.60793790061568, 23.779378764292023]
            ]
          ],
          [
            [
              [119.60690409042796, 23.778486806342684],
              [119.60690409042796, 23.778486806342684]
            ]
          ],
          [
            [
              [119.6112817555867, 23.77760141495128],
              [119.6112817555867, 23.77760141495128]
            ]
          ],
          [
            [
              [119.61249725415368, 23.77661224867193],
              [119.61249725415368, 23.77661224867193]
            ]
          ],
          [
            [
              [119.60748532351599, 23.77823621176719],
              [119.60748532351599, 23.77823621176719]
            ]
          ],
          [
            [
              [119.61209402347242, 23.7774242367],
              [119.61209402347242, 23.7774242367]
            ]
          ],
          [
            [
              [119.61077937525819, 23.7770664713042],
              [119.61077937525819, 23.7770664713042]
            ]
          ],
          [
            [
              [119.61111513856247, 23.776681393178222],
              [119.61111513856247, 23.776681393178222]
            ]
          ],
          [
            [
              [119.61177464580926, 23.77605754738749],
              [119.61177464580926, 23.77605754738749]
            ]
          ],
          [
            [
              [119.61169434321634, 23.775565762824684],
              [119.61169434321634, 23.775565762824684]
            ]
          ],
          [
            [
              [119.59878087257098, 23.768807651415997],
              [119.59878087257098, 23.768807651415997]
            ]
          ],
          [
            [
              [119.60768870870234, 23.774767962939425],
              [119.60768870870234, 23.774767962939425]
            ]
          ],
          [
            [
              [119.60794844516035, 23.774410278794566],
              [119.60794844516035, 23.774410278794566]
            ]
          ],
          [
            [
              [119.58738922732823, 23.767984376468057],
              [119.58738922732823, 23.767984376468057]
            ]
          ],
          [
            [
              [119.5848964836195, 23.766229676767963],
              [119.5848964836195, 23.766229676767963]
            ]
          ],
          [
            [
              [119.60257441462552, 23.76692048052376],
              [119.60257441462552, 23.76692048052376]
            ]
          ],
          [
            [
              [119.60367975460612, 23.766461828106873],
              [119.60367975460612, 23.766461828106873]
            ]
          ],
          [
            [
              [119.60550770953463, 23.765589834709452],
              [119.60550770953463, 23.765589834709452]
            ]
          ],
          [
            [
              [119.6074749121748, 23.764671765107092],
              [119.6074749121748, 23.764671765107092]
            ]
          ],
          [
            [
              [119.60682536470078, 23.75913474869483],
              [119.60682536470078, 23.75913474869483]
            ]
          ],
          [
            [
              [119.6062348264719, 23.751412448070766],
              [119.62375359314977, 23.74376019342585],
              [119.62378032913627, 23.74371042330675],
              [119.6026721975143, 23.725393452712513],
              [119.60261572586397, 23.725375613752764],
              [119.6062348264719, 23.751412448070766]
            ]
          ],
          [
            [
              [119.60801885712685, 23.75785676073648],
              [119.60801885712685, 23.75785676073648]
            ]
          ],
          [
            [
              [119.60700794904675, 23.756650934485805],
              [119.60700794904675, 23.756650934485805]
            ]
          ],
          [
            [
              [119.59864460194066, 23.753871226865233],
              [119.59864460194066, 23.753871226865233]
            ]
          ],
          [
            [
              [119.6091621357242, 23.736702529676027],
              [119.6091621357242, 23.736702529676027]
            ]
          ],
          [
            [
              [119.61113379011745, 23.735141049486348],
              [119.61113379011745, 23.735141049486348]
            ]
          ],
          [
            [
              [119.6106835222903, 23.733197302783907],
              [119.6106835222903, 23.733197302783907]
            ]
          ],
          [
            [
              [119.61265116429146, 23.732495885559977],
              [119.61265116429146, 23.732495885559977]
            ]
          ],
          [
            [
              [119.60992528954053, 23.731110119807198],
              [119.60992528954053, 23.731110119807198]
            ]
          ],
          [
            [
              [119.55521722916662, 23.708643480126476],
              [119.55521722916662, 23.708643480126476]
            ]
          ],
          [
            [
              [119.611424898758, 23.7154599380623],
              [119.611424898758, 23.7154599380623]
            ]
          ],
          [
            [
              [119.61209933992946, 23.715120922529948],
              [119.61209933992946, 23.715120922529948]
            ]
          ],
          [
            [
              [119.61252833487343, 23.714119054463215],
              [119.61252833487343, 23.714119054463215]
            ]
          ],
          [
            [
              [119.60800637814944, 23.710571514745084],
              [119.60800637814944, 23.710571514745084]
            ]
          ],
          [
            [
              [119.60943119931987, 23.71340519260276],
              [119.60943119931987, 23.71340519260276]
            ]
          ],
          [
            [
              [119.60992191029325, 23.71305562123424],
              [119.60992191029325, 23.71305562123424]
            ]
          ],
          [
            [
              [119.61018919630631, 23.71254213837905],
              [119.61018919630631, 23.71254213837905]
            ]
          ],
          [
            [
              [119.56675731355304, 23.710495825329637],
              [119.56675731355304, 23.710495825329637]
            ]
          ],
          [
            [
              [119.60953595387258, 23.70892161784651],
              [119.60953595387258, 23.70892161784651]
            ]
          ],
          [
            [
              [119.60836892658196, 23.710179205452388],
              [119.60836892658196, 23.710179205452388]
            ]
          ],
          [
            [
              [119.59355570667259, 23.694924654206606],
              [119.59355570667259, 23.694924654206606]
            ]
          ],
          [
            [
              [119.56499979668105, 23.693613780833516],
              [119.56499979668105, 23.693613780833516]
            ]
          ],
          [
            [
              [119.59489895167722, 23.691182742275775],
              [119.59489895167722, 23.691182742275775]
            ]
          ],
          [
            [
              [119.67004416507173, 23.692783532032553],
              [119.67004416507173, 23.692783532032553]
            ]
          ],
          [
            [
              [119.55965364915528, 23.69338787278773],
              [119.55965364915528, 23.69338787278773]
            ]
          ],
          [
            [
              [119.65244273301397, 23.690709906437213],
              [119.65244273301397, 23.690709906437213]
            ]
          ],
          [
            [
              [119.55957037643407, 23.693045046327594],
              [119.55957037643407, 23.693045046327594]
            ]
          ],
          [
            [
              [119.55719712652488, 23.690855474299344],
              [119.55719712652488, 23.690855474299344]
            ]
          ],
          [
            [
              [119.67077334676198, 23.6907735813221],
              [119.67077334676198, 23.6907735813221]
            ]
          ],
          [
            [
              [119.59669231363573, 23.690146105383366],
              [119.59669231363573, 23.690146105383366]
            ]
          ],
          [
            [
              [119.67173891014728, 23.682468968946726],
              [119.67173891014728, 23.682468968946726]
            ]
          ],
          [
            [
              [119.5581026366234, 23.68811155183546],
              [119.5581026366234, 23.68811155183546]
            ]
          ],
          [
            [
              [119.65167738291935, 23.688458146787646],
              [119.65167738291935, 23.688458146787646]
            ]
          ],
          [
            [
              [119.65486231599986, 23.688532767541652],
              [119.65486231599986, 23.688532767541652]
            ]
          ],
          [
            [
              [119.66995890316906, 23.687894573324098],
              [119.66995890316906, 23.687894573324098]
            ]
          ],
          [
            [
              [119.65524639625808, 23.6849690105279],
              [119.65524639625808, 23.6849690105279]
            ]
          ],
          [
            [
              [119.65444094271561, 23.684913724921273],
              [119.65444094271561, 23.684913724921273]
            ]
          ],
          [
            [
              [119.65411118685076, 23.685019083100133],
              [119.65411118685076, 23.685019083100133]
            ]
          ],
          [
            [
              [119.62312739686942, 23.68457651735391],
              [119.62312739686942, 23.68457651735391]
            ]
          ],
          [
            [
              [119.65591994934718, 23.68487162031925],
              [119.65591994934718, 23.68487162031925]
            ]
          ],
          [
            [
              [119.65517331892052, 23.684691664262342],
              [119.65517331892052, 23.684691664262342]
            ]
          ],
          [
            [
              [119.65472391108543, 23.684641645517825],
              [119.65472391108543, 23.684641645517825]
            ]
          ],
          [
            [
              [119.6540324267108, 23.68452279617024],
              [119.6540324267108, 23.68452279617024]
            ]
          ],
          [
            [
              [119.654334856894, 23.684406266826347],
              [119.654334856894, 23.684406266826347]
            ]
          ],
          [
            [
              [119.66809525594762, 23.682802664186113],
              [119.66809525594762, 23.682802664186113]
            ]
          ],
          [
            [
              [119.66801844985983, 23.676037674242554],
              [119.66801844985983, 23.676037674242554]
            ]
          ],
          [
            [
              [119.66430056585095, 23.68157399734408],
              [119.66430056585095, 23.68157399734408]
            ]
          ],
          [
            [
              [119.65807019513615, 23.676193382107808],
              [119.65807019513615, 23.676193382107808]
            ]
          ],
          [
            [
              [119.66868685079544, 23.673436567455482],
              [119.66868685079544, 23.673436567455482]
            ]
          ],
          [
            [
              [119.55630272715892, 23.67343145157141],
              [119.55630272715892, 23.67343145157141]
            ]
          ],
          [
            [
              [119.61429753843471, 23.665268367703536],
              [119.61429753843471, 23.665268367703536]
            ]
          ],
          [
            [
              [119.61224355611031, 23.67061357711372],
              [119.61224355611031, 23.67061357711372]
            ]
          ],
          [
            [
              [119.65922418739068, 23.659028306557612],
              [119.65922418739068, 23.659028306557612]
            ]
          ],
          [
            [
              [119.55441689404003, 23.669091972024074],
              [119.55441689404003, 23.669091972024074]
            ]
          ],
          [
            [
              [119.55489167522865, 23.668713285258285],
              [119.55489167522865, 23.668713285258285]
            ]
          ],
          [
            [
              [119.5490480186383, 23.66296308176129],
              [119.5490480186383, 23.66296308176129]
            ]
          ],
          [
            [
              [119.54773961001663, 23.65334248302214],
              [119.54773961001663, 23.65334248302214]
            ]
          ],
          [
            [
              [119.54903736926357, 23.65384085438924],
              [119.54903736926357, 23.65384085438924]
            ]
          ],
          [
            [
              [119.5491911195469, 23.65332335753713],
              [119.5491911195469, 23.65332335753713]
            ]
          ],
          [
            [
              [119.54961965324465, 23.65299215422779],
              [119.54961965324465, 23.65299215422779]
            ]
          ],
          [
            [
              [119.63394636370415, 23.642949050212863],
              [119.63394636370415, 23.642949050212863]
            ]
          ],
          [
            [
              [119.5474700922529, 23.65215149698015],
              [119.5474700922529, 23.65215149698015]
            ]
          ],
          [
            [
              [119.54547239098956, 23.649778837802856],
              [119.54547239098956, 23.649778837802856]
            ]
          ],
          [
            [
              [119.54439991106702, 23.648490747792806],
              [119.54439991106702, 23.648490747792806]
            ]
          ],
          [
            [
              [119.54511559557373, 23.64871467652224],
              [119.54511559557373, 23.64871467652224]
            ]
          ],
          [
            [
              [119.58177947423643, 23.64836851377479],
              [119.58177947423643, 23.64836851377479]
            ]
          ],
          [
            [
              [119.58792021469577, 23.639504891993372],
              [119.58792021469577, 23.639504891993372]
            ]
          ],
          [
            [
              [119.60498276295667, 23.638808233206063],
              [119.60498276295667, 23.638808233206063]
            ]
          ],
          [
            [
              [119.60832924588733, 23.637304505795846],
              [119.60832924588733, 23.637304505795846]
            ]
          ],
          [
            [
              [119.61743990940167, 23.630041940113117],
              [119.61743990940167, 23.630041940113117]
            ]
          ],
          [
            [
              [119.56987512792205, 23.616547534938416],
              [119.56987512792205, 23.616547534938416]
            ]
          ],
          [
            [
              [119.5986425734654, 23.607720576642997],
              [119.5986425734654, 23.607720576642997]
            ]
          ],
          [
            [
              [119.61394876700066, 23.60689569260048],
              [119.61394876700066, 23.60689569260048]
            ]
          ],
          [
            [
              [119.50844550217951, 23.27272511892277],
              [119.50844550217951, 23.27272511892277]
            ]
          ],
          [
            [
              [119.50907287454731, 23.25565093706131],
              [119.52215549323924, 23.26310242799494],
              [119.5221732896443, 23.262842653340627],
              [119.50907287454731, 23.25565093706131]
            ]
          ],
          [
            [
              [119.66541259056373, 23.25860948439445],
              [119.68005393877905, 23.26027393095548],
              [119.68008169146819, 23.260206088614552],
              [119.6711710080489, 23.24393242114106],
              [119.67108358522317, 23.243914735061352],
              [119.66541259056373, 23.25860948439445]
            ]
          ],
          [
            [
              [119.65996929050412, 23.25994866055837],
              [119.65996929050412, 23.25994866055837]
            ]
          ],
          [
            [
              [119.50258626781509, 23.257718953351958],
              [119.50258626781509, 23.257718953351958]
            ]
          ],
          [
            [
              [119.61830446346521, 23.255014402354195],
              [119.61830446346521, 23.255014402354195]
            ]
          ],
          [
            [
              [119.61007536234963, 23.247253480208183],
              [119.62230049845353, 23.245340229588077],
              [119.62235684168168, 23.245308402226428],
              [119.61007536234963, 23.247253480208183]
            ]
          ],
          [
            [
              [119.51871888643164, 23.252316522249636],
              [119.51871888643164, 23.252316522249636]
            ]
          ],
          [
            [
              [119.55118221770596, 23.243816182511484],
              [119.55118221770596, 23.243816182511484]
            ]
          ],
          [
            [
              [119.55021083213985, 23.24228461266891],
              [119.55021083213985, 23.24228461266891]
            ]
          ],
          [
            [
              [119.55068077369057, 23.241867493932535],
              [119.55068077369057, 23.241867493932535]
            ]
          ],
          [
            [
              [119.52002110518815, 23.233706076824717],
              [119.52002110518815, 23.233706076824717]
            ]
          ],
          [
            [
              [119.49235180256075, 23.381389621801752],
              [119.49070272673008, 23.39673030202507],
              [119.49071323787793, 23.3967618741174],
              [119.50526766465177, 23.39487130134234],
              [119.50533580613342, 23.39486205109596],
              [119.51658259803116, 23.372962626256577],
              [119.51663324071215, 23.372858615855154],
              [119.51314393962112, 23.35253737671376],
              [119.51309667469839, 23.352485610419496],
              [119.49078745875637, 23.353043078402816],
              [119.49070920450595, 23.353038808765472],
              [119.49235180256075, 23.381389621801752]
            ]
          ],
          [
            [
              [119.31515747662527, 23.400415917448868],
              [119.3306803931214, 23.404963525668332],
              [119.33068812955949, 23.40487772247965],
              [119.31515747662527, 23.400415917448868]
            ]
          ],
          [
            [
              [119.5137007387481, 23.39538927430179],
              [119.5137007387481, 23.39538927430179]
            ]
          ],
          [
            [
              [119.51431336093982, 23.38067962585636],
              [119.51431336093982, 23.38067962585636]
            ]
          ],
          [
            [
              [119.52896096414055, 23.3762153344405],
              [119.52896096414055, 23.3762153344405]
            ]
          ],
          [
            [
              [119.48746348576539, 23.378067965892633],
              [119.48746348576539, 23.378067965892633]
            ]
          ],
          [
            [
              [119.52357429905527, 23.36598331617226],
              [119.53659892914061, 23.375738436566696],
              [119.53664284693446, 23.37579020838043],
              [119.54389020298889, 23.365395125581966],
              [119.5438963083114, 23.36531835044524],
              [119.52357429905527, 23.36598331617226]
            ]
          ],
          [
            [
              [119.52692434707983, 23.373324742043906],
              [119.52692434707983, 23.373324742043906]
            ]
          ],
          [
            [
              [119.53142788018278, 23.37399696385407],
              [119.53142788018278, 23.37399696385407]
            ]
          ],
          [
            [
              [119.55202591379673, 23.365665609237332],
              [119.55202591379673, 23.365665609237332]
            ]
          ],
          [
            [
              [119.55308369741091, 23.363502152676368],
              [119.55308369741091, 23.363502152676368]
            ]
          ],
          [
            [
              [119.53765193379273, 23.359959552226638],
              [119.53765193379273, 23.359959552226638]
            ]
          ],
          [
            [
              [119.4811744736785, 23.356044786957224],
              [119.4811744736785, 23.356044786957224]
            ]
          ],
          [
            [
              [119.51775617384072, 23.356325782363733],
              [119.51775617384072, 23.356325782363733]
            ]
          ],
          [
            [
              [119.46068663123394, 23.353879452457203],
              [119.46068663123394, 23.353879452457203]
            ]
          ],
          [
            [
              [119.52752432258137, 23.355195195540226],
              [119.52752432258137, 23.355195195540226]
            ]
          ],
          [
            [
              [119.46350113113989, 23.35446817186277],
              [119.46350113113989, 23.35446817186277]
            ]
          ],
          [
            [
              [119.46771271948145, 23.350810020590377],
              [119.46771271948145, 23.350810020590377]
            ]
          ],
          [
            [
              [119.51969557243407, 23.35162546069125],
              [119.51969557243407, 23.35162546069125]
            ]
          ],
          [
            [
              [119.5197711771052, 23.351295621843587],
              [119.5197711771052, 23.351295621843587]
            ]
          ],
          [
            [
              [119.53877477622466, 23.349165373734426],
              [119.53877477622466, 23.349165373734426]
            ]
          ],
          [
            [
              [119.46489984517211, 23.346943263331042],
              [119.46489984517211, 23.346943263331042]
            ]
          ],
          [
            [
              [119.32109092916907, 23.323346160822137],
              [119.32109092916907, 23.323346160822137]
            ]
          ],
          [
            [
              [119.32281896403887, 23.324096165656197],
              [119.32281896403887, 23.324096165656197]
            ]
          ],
          [
            [
              [119.3244747787332, 23.323618446652308],
              [119.3244747787332, 23.323618446652308]
            ]
          ],
          [
            [
              [119.33687546547934, 23.31711373734674],
              [119.33687546547934, 23.31711373734674]
            ]
          ],
          [
            [
              [119.34218627800531, 23.307166255319228],
              [119.34218627800531, 23.307166255319228]
            ]
          ],
          [
            [
              [119.50094109360498, 23.2905726675279],
              [119.50094109360498, 23.2905726675279]
            ]
          ],
          [
            [
              [119.50114388213504, 23.288912788520243],
              [119.50114388213504, 23.288912788520243]
            ]
          ],
          [
            [
              [119.50033413385636, 23.286630930406012],
              [119.50033413385636, 23.286630930406012]
            ]
          ],
          [
            [
              [119.50121456044968, 23.276374625465746],
              [119.50121456044968, 23.276374625465746]
            ]
          ],
          [
            [
              [119.5015549348631, 23.275463786230418],
              [119.5015549348631, 23.275463786230418]
            ]
          ],
          [
            [
              [119.51119111965568, 23.266343072072743],
              [119.51119111965568, 23.266343072072743]
            ]
          ],
          [
            [
              [119.6968564722772, 23.554030811469726],
              [119.6968564722772, 23.554030811469726]
            ]
          ],
          [
            [
              [119.65949878320231, 23.542928555949167],
              [119.65949878320231, 23.542928555949167]
            ]
          ],
          [
            [
              [119.65949971929233, 23.541526698627084],
              [119.65949971929233, 23.541526698627084]
            ]
          ],
          [
            [
              [119.66101689651197, 23.539472675299937],
              [119.66101689651197, 23.539472675299937]
            ]
          ],
          [
            [
              [119.72692445169116, 23.534980432252244],
              [119.72692445169116, 23.534980432252244]
            ]
          ],
          [
            [
              [119.60477233864844, 23.596513755266592],
              [119.60477233864844, 23.596513755266592]
            ]
          ],
          [
            [
              [119.68493574031159, 23.624759326518035],
              [119.68493574031159, 23.624759326518035]
            ]
          ],
          [
            [
              [119.69976051542685, 23.617030182400025],
              [119.69976051542685, 23.617030182400025]
            ]
          ],
          [
            [
              [119.69532646903673, 23.61891908894895],
              [119.69532646903673, 23.61891908894895]
            ]
          ],
          [
            [
              [119.69817507427862, 23.617935853804955],
              [119.69817507427862, 23.617935853804955]
            ]
          ],
          [
            [
              [119.70212127639681, 23.616586972717315],
              [119.70212127639681, 23.616586972717315]
            ]
          ],
          [
            [
              [119.69952604535447, 23.615615894441994],
              [119.69952604535447, 23.615615894441994]
            ]
          ],
          [
            [
              [119.70102580263607, 23.61589001633379],
              [119.70102580263607, 23.61589001633379]
            ]
          ],
          [
            [
              [119.70004204214237, 23.615007448072046],
              [119.70004204214237, 23.615007448072046]
            ]
          ],
          [
            [
              [119.67637080799054, 23.60260137287562],
              [119.67637080799054, 23.60260137287562]
            ]
          ],
          [
            [
              [119.6748656432504, 23.602439531573634],
              [119.6748656432504, 23.602439531573634]
            ]
          ],
          [
            [
              [119.67521399716321, 23.598407164510814],
              [119.67521399716321, 23.598407164510814]
            ]
          ],
          [
            [
              [119.67854557379134, 23.59821764337673],
              [119.67854557379134, 23.59821764337673]
            ]
          ],
          [
            [
              [119.69374250416152, 23.56390042152019],
              [119.69374250416152, 23.56390042152019]
            ]
          ],
          [
            [
              [119.68906009375095, 23.56220505509927],
              [119.68906009375095, 23.56220505509927]
            ]
          ],
          [
            [
              [119.72470909370449, 23.55717931492581],
              [119.72470909370449, 23.55717931492581]
            ]
          ],
          [
            [
              [119.69594729373577, 23.556949270635],
              [119.69594729373577, 23.556949270635]
            ]
          ],
          [
            [
              [119.52618915509113, 23.65463989278224],
              [119.52618915509113, 23.65463989278224]
            ]
          ],
          [
            [
              [119.53870163887608, 23.643213703003152],
              [119.53870163887608, 23.643213703003152]
            ]
          ],
          [
            [
              [119.53880474283538, 23.641520238885263],
              [119.53880474283538, 23.641520238885263]
            ]
          ],
          [
            [
              [119.53894811842773, 23.640436752915026],
              [119.53894811842773, 23.640436752915026]
            ]
          ],
          [
            [
              [119.55142010307118, 23.594201820349582],
              [119.55142010307118, 23.594201820349582]
            ]
          ],
          [
            [
              [119.54021461327211, 23.580200781233334],
              [119.54021461327211, 23.580200781233334]
            ]
          ],
          [
            [
              [119.58814224844907, 23.594758441674532],
              [119.58814224844907, 23.594758441674532]
            ]
          ],
          [
            [
              [119.5417878141088, 23.5527883123888],
              [119.5417878141088, 23.5527883123888]
            ]
          ],
          [
            [
              [119.54136179713555, 23.554107507987084],
              [119.54136179713555, 23.554107507987084]
            ]
          ],
          [
            [
              [119.53255018918301, 23.538718934291747],
              [119.53255018918301, 23.538718934291747]
            ]
          ],
          [
            [
              [119.52872453778774, 23.540803173978407],
              [119.52872453778774, 23.540803173978407]
            ]
          ],
          [
            [
              [119.5295003710475, 23.54102054337776],
              [119.5295003710475, 23.54102054337776]
            ]
          ],
          [
            [
              [119.52426089144578, 23.539989929578276],
              [119.52426089144578, 23.539989929578276]
            ]
          ],
          [
            [
              [119.5192048598567, 23.508743728596976],
              [119.5192048598567, 23.508743728596976]
            ]
          ],
          [
            [
              [119.51170019758015, 23.483003110476456],
              [119.54377779469769, 23.494487289683253],
              [119.54383483256176, 23.494295206422656],
              [119.51170019758015, 23.483003110476456]
            ]
          ],
          [
            [
              [119.58096029613954, 23.661552068087516],
              [119.5180990969942, 23.629083900019072],
              [119.51804711641675, 23.629027636242174],
              [119.51652159085671, 23.565187236869637],
              [119.51619596598076, 23.56481358384165],
              [119.46797401340164, 23.560534985414],
              [119.46791657076614, 23.560564505327182],
              [119.50332901941164, 23.579108490972274],
              [119.50335410773144, 23.57915130149758],
              [119.48952629966143, 23.594251543531193],
              [119.48951359903072, 23.594294475776167],
              [119.50441508324644, 23.597311320816857],
              [119.50446802672488, 23.59743982549606],
              [119.51416571594551, 23.655457847229286],
              [119.51420031394167, 23.655532228329864],
              [119.53822250096495, 23.63956512695457],
              [119.53832116130144, 23.63957381440924],
              [119.55505324034513, 23.668450847198457],
              [119.5551771940932, 23.668567788377185],
              [119.5821594980181, 23.67751918882799],
              [119.58228577032362, 23.677530001197052],
              [119.60969705709863, 23.663716810333767],
              [119.6098029612125, 23.663592237673967],
              [119.59730430102545, 23.639753171112076],
              [119.59730813716624, 23.63958610620134],
              [119.61025029615598, 23.63578605873935],
              [119.61032185797413, 23.635697738902923],
              [119.6127361174016, 23.60190975551292],
              [119.61277402475262, 23.601830595971112],
              [119.63079690317021, 23.607336400556786],
              [119.63084877192458, 23.60729781403972],
              [119.62412769501985, 23.579542738395286],
              [119.62415834691, 23.579486179383778],
              [119.65467855799288, 23.608891802308612],
              [119.65479282049665, 23.608902607093775],
              [119.69592470243693, 23.55393577621219],
              [119.69594555571378, 23.553827328495917],
              [119.64570625069351, 23.560336683200248],
              [119.64529843310409, 23.560189386201493],
              [119.60569668946941, 23.52914510377589],
              [119.60545230766581, 23.528864703496417],
              [119.60748248969128, 23.50811288279031],
              [119.60739906529199, 23.508002595043433],
              [119.5719608831456, 23.508529805476748],
              [119.57180967829908, 23.508659035569043],
              [119.54219660532681, 23.547940102094373],
              [119.54220180814957, 23.548014578233293],
              [119.5742669169097, 23.519741599630656],
              [119.57436431198508, 23.519691576613265],
              [119.59601287840938, 23.526674602345913],
              [119.59611323883878, 23.526739683624488],
              [119.60410363537063, 23.548259203390767],
              [119.6040980090307, 23.548367581674412],
              [119.56477666122377, 23.547817461326314],
              [119.56458651412697, 23.547872329787793],
              [119.57900130243699, 23.562659991516302],
              [119.57978205375335, 23.563401919181207],
              [119.55570675553014, 23.56327640168751],
              [119.55570266999091, 23.5633239304635],
              [119.56166487888737, 23.585026070021296],
              [119.56166508063885, 23.585073476419918],
              [119.5832305903517, 23.594174860118503],
              [119.58336245517948, 23.594268200675632],
              [119.5969796920797, 23.569011036070375],
              [119.59726445039935, 23.569025104666785],
              [119.61251439608479, 23.605384941500365],
              [119.6125527966217, 23.605411879392893],
              [119.59745397106455, 23.615760576873278],
              [119.59729442852547, 23.61593953100528],
              [119.60450956508234, 23.6250216763679],
              [119.6045094530876, 23.625021832587265],
              [119.58859453960355, 23.622589040945318],
              [119.58849196699536, 23.62266166789356],
              [119.58096029613954, 23.661552068087516]
            ]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10005001", "COUNTYNAME": "苗栗县", "name": "苗栗县" },
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [120.6630535565653, 24.4813427025911],
              [120.6630535565653, 24.4813427025911]
            ]
          ],
          [
            [
              [120.66211916770776, 24.480606222736387],
              [120.66211916770776, 24.480606222736387]
            ]
          ],
          [
            [
              [121.20327673096067, 24.512500477758763],
              [121.21638755763252, 24.515339905923],
              [121.21671309256396, 24.515086628951916],
              [121.26260369556489, 24.455323912752437],
              [121.26262238746385, 24.455269697403477],
              [121.23159038694281, 24.38420616047243],
              [121.23156523952818, 24.384100107282258],
              [121.19693809116947, 24.39674322780428],
              [121.19662909545153, 24.39662850856685],
              [121.16815130411312, 24.361114370172793],
              [121.16797586234145, 24.360976870470502],
              [121.1407834843159, 24.359628461489457],
              [121.14061650953296, 24.35959927173276],
              [121.12141510541203, 24.33076517049706],
              [121.12123650331685, 24.33061867949297],
              [121.0734875053939, 24.32277943510428],
              [121.07286579104276, 24.32283842453333],
              [121.04599923777393, 24.295601692688972],
              [121.04510058601093, 24.2953220560659],
              [121.00442448908025, 24.332089892240372],
              [121.00359776503879, 24.332482683639135],
              [120.93580243460679, 24.34283754841233],
              [120.93566937080828, 24.342855550386474],
              [120.91648749146688, 24.33489111653309],
              [120.91634962758512, 24.334728506410812],
              [120.91234791956528, 24.294567503867523],
              [120.91183956024862, 24.29401868445068],
              [120.8343759553163, 24.290225299831263],
              [120.83371257889391, 24.290447958005768],
              [120.69311229192132, 24.36690439999363],
              [120.69276390982127, 24.3671475240674],
              [120.62133405430814, 24.440735720802024],
              [120.62117546748395, 24.44094524622248],
              [120.67714282750727, 24.496501812168162],
              [120.67722194586106, 24.4966103190094],
              [120.72318905178408, 24.60554529300485],
              [120.72326960092451, 24.605660865165824],
              [120.75886196958893, 24.613157125280793],
              [120.75897047741641, 24.61322727229968],
              [120.76843685755071, 24.654607412047888],
              [120.76846817663625, 24.654669298217637],
              [120.8282299901528, 24.669490086966558],
              [120.82872345360992, 24.6695583660581],
              [120.8656385748841, 24.72421072245506],
              [120.86592073775557, 24.724531584094485],
              [120.90704388643242, 24.7409510879185],
              [120.9074395586178, 24.741084424643866],
              [120.91365553845026, 24.717355555266206],
              [120.91376230832081, 24.717281211021756],
              [120.97496866345728, 24.711033558652357],
              [120.97514290026585, 24.710900413830984],
              [120.9643978112313, 24.683651241119374],
              [120.96444183866328, 24.683576664934222],
              [121.0515186623476, 24.615197801402374],
              [121.05159394534361, 24.61513674061763],
              [121.0746412416003, 24.612562718846],
              [121.07495459899775, 24.612212677274478],
              [121.08309887051836, 24.590129999274858],
              [121.08308550458737, 24.589983377785906],
              [121.05658610674683, 24.55941378751195],
              [121.0565754191504, 24.559312116956303],
              [121.08041860104848, 24.541177604260156],
              [121.0805186759485, 24.540895396796635],
              [121.07192775816382, 24.498571141130153],
              [121.0718607270003, 24.498365763700985],
              [121.20327673096067, 24.512500477758763]
            ]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10020001", "COUNTYNAME": "嘉义市", "name": "嘉义市" },
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [120.42862377845057, 23.50917284730983],
            [120.44657254030336, 23.518333172455023],
            [120.44678767038137, 23.518333936957458],
            [120.46423723081975, 23.49914289850534],
            [120.46443843362734, 23.499060145029112],
            [120.48256805744322, 23.50508368620406],
            [120.48316606308609, 23.505367874038154],
            [120.50927315127988, 23.474742327654077],
            [120.50936058852785, 23.474302464295626],
            [120.49528003076018, 23.452982685031028],
            [120.49523235445339, 23.452892231050484],
            [120.46992714593286, 23.46173900691649],
            [120.4686881720279, 23.461599261462542],
            [120.43969330927787, 23.439563504368927],
            [120.43952624521339, 23.43958096449851],
            [120.43012270313083, 23.45254765188616],
            [120.42930183817928, 23.461035199787425],
            [120.39514065065268, 23.462540570087526],
            [120.39414145043601, 23.46252766245565],
            [120.38943636053666, 23.498648394521304],
            [120.38944255251171, 23.498731863276497],
            [120.42862377845057, 23.50917284730983]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10004001", "COUNTYNAME": "新竹县", "name": "新竹县" },
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [120.94913486248821, 24.881660170378517],
            [120.98122281066756, 24.939472847223694],
            [120.98143039090763, 24.939624641573964],
            [121.03783828969436, 24.9463466669537],
            [121.03802924971664, 24.94637145559321],
            [121.05810633856692, 24.936731865620253],
            [121.0583551258982, 24.936684450278168],
            [121.06024129049618, 24.903907442543144],
            [121.06043844528163, 24.903756225778118],
            [121.15554075952312, 24.88071698784027],
            [121.15571048441232, 24.880653611368874],
            [121.1499419566667, 24.844429239391058],
            [121.14996471226108, 24.844325288907733],
            [121.22154430202643, 24.799389819120616],
            [121.22163199864558, 24.799342289210497],
            [121.24326088230227, 24.8087144187408],
            [121.24348736492273, 24.80866204578784],
            [121.25986542358704, 24.782139514457604],
            [121.26001585706226, 24.78195641539203],
            [121.30139293409829, 24.763103527384203],
            [121.30160160669453, 24.762888588170014],
            [121.29955011913374, 24.695522084061448],
            [121.29963337101631, 24.695339069282916],
            [121.32344918286906, 24.695246474696017],
            [121.32392546465238, 24.69504002766734],
            [121.33905306106323, 24.666704511472574],
            [121.33920308212417, 24.666521414258472],
            [121.35343583153038, 24.667750633243998],
            [121.35350923245709, 24.66772111736034],
            [121.3632766140112, 24.60331259715134],
            [121.36335924892019, 24.60307548350272],
            [121.40224130989692, 24.591713847741968],
            [121.40302476368747, 24.59172537713487],
            [121.41227243066554, 24.57390734643387],
            [121.41232951565638, 24.573439952765096],
            [121.39482770939581, 24.556050311896414],
            [121.39473511011538, 24.555836120968166],
            [121.40153324590958, 24.529002384852596],
            [121.4014158256162, 24.528835754750673],
            [121.30498542955645, 24.433000987370125],
            [121.3046937892466, 24.432836778020697],
            [121.25946177429763, 24.42912124106754],
            [121.25917201505092, 24.429388192703286],
            [121.26262238746385, 24.455269697403477],
            [121.26260369556489, 24.455323912752437],
            [121.21638755763252, 24.515339905923],
            [121.21605532764411, 24.515464529607232],
            [121.07290996077784, 24.49880993808463],
            [121.0718607270003, 24.498365763700985],
            [121.08050181498967, 24.540574878768396],
            [121.0805186759485, 24.540895396796635],
            [121.05667787372111, 24.559029906927872],
            [121.0565754191504, 24.559312116956303],
            [121.0830100995971, 24.589820899691535],
            [121.08308550458737, 24.589983377785906],
            [121.07536173532178, 24.611456290025473],
            [121.07518019762306, 24.611867193329225],
            [121.05173545645265, 24.615134525106196],
            [121.05159394534361, 24.61513674061763],
            [120.9646175564032, 24.68358347801405],
            [120.96444183866328, 24.683576664934222],
            [120.97386856187026, 24.71179406874547],
            [120.97381201906953, 24.711873069305906],
            [120.93567392100013, 24.712267821810315],
            [120.93546081897493, 24.71251611055893],
            [120.94394253143479, 24.74399237780068],
            [120.94416100341994, 24.74428137740302],
            [120.9855623201935, 24.77613605957884],
            [120.98581749130342, 24.776932943833557],
            [121.02035058784209, 24.756737864245917],
            [121.02062216982951, 24.756606902274566],
            [121.03343820895302, 24.763378712547325],
            [121.03355249036268, 24.763760057915505],
            [121.01040337396789, 24.81370282933389],
            [121.00837282485409, 24.81611819934279],
            [120.93435911988597, 24.85263789661772],
            [120.93364814494589, 24.852763991399165],
            [120.94913486248821, 24.881660170378517]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10001001", "COUNTYNAME": "新北市", "name": "新北市" },
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [121.53890224933585, 25.301128098451287],
              [121.53890224933585, 25.301128098451287]
            ]
          ],
          [
            [
              [121.53747551797932, 25.300765062791466],
              [121.53747551797932, 25.300765062791466]
            ]
          ],
          [
            [
              [121.5384201635095, 25.300617976245217],
              [121.5384201635095, 25.300617976245217]
            ]
          ],
          [
            [
              [121.53785037428365, 25.300416334930894],
              [121.53785037428365, 25.300416334930894]
            ]
          ],
          [
            [
              [121.53642072511028, 25.300170046569708],
              [121.53642072511028, 25.300170046569708]
            ]
          ],
          [
            [
              [121.53882451529134, 25.299983310289974],
              [121.53882451529134, 25.299983310289974]
            ]
          ],
          [
            [
              [121.53998938492246, 25.298537054359347],
              [121.53998938492246, 25.298537054359347]
            ]
          ],
          [
            [
              [121.51128792872161, 25.29150663307782],
              [121.51128792872161, 25.29150663307782]
            ]
          ],
          [
            [
              [121.51038693090288, 25.291200939322714],
              [121.51038693090288, 25.291200939322714]
            ]
          ],
          [
            [
              [121.51225758586003, 25.291097948010968],
              [121.51225758586003, 25.291097948010968]
            ]
          ],
          [
            [
              [121.50964599215452, 25.29105149998315],
              [121.50964599215452, 25.29105149998315]
            ]
          ],
          [
            [
              [121.50885447450031, 25.29089741053137],
              [121.50885447450031, 25.29089741053137]
            ]
          ],
          [
            [
              [121.50879581074608, 25.290195538852156],
              [121.50879581074608, 25.290195538852156]
            ]
          ],
          [
            [
              [121.70206869384431, 25.217128691555217],
              [121.70206869384431, 25.217128691555217]
            ]
          ],
          [
            [
              [121.7035841843411, 25.216990729270297],
              [121.7035841843411, 25.216990729270297]
            ]
          ],
          [
            [
              [121.70209632864572, 25.216025449511804],
              [121.70209632864572, 25.216025449511804]
            ]
          ],
          [
            [
              [121.7010771148737, 25.215423228870183],
              [121.7010771148737, 25.215423228870183]
            ]
          ],
          [
            [
              [121.6983833169927, 25.21546215065295],
              [121.6983833169927, 25.21546215065295]
            ]
          ],
          [
            [
              [121.69615995183698, 25.212699672782538],
              [121.69615995183698, 25.212699672782538]
            ]
          ],
          [
            [
              [121.69561624361495, 25.212265670595144],
              [121.69561624361495, 25.212265670595144]
            ]
          ],
          [
            [
              [121.69913795650224, 25.206313032369923],
              [121.69913795650224, 25.206313032369923]
            ]
          ],
          [
            [
              [121.69708677436961, 25.204325101984452],
              [121.69708677436961, 25.204325101984452]
            ]
          ],
          [
            [
              [121.69580424212938, 25.203384379395537],
              [121.69580424212938, 25.203384379395537]
            ]
          ],
          [
            [
              [121.67841300648253, 25.20285364577959],
              [121.67841300648253, 25.20285364577959]
            ]
          ],
          [
            [
              [121.69494139216924, 25.202495153843433],
              [121.69494139216924, 25.202495153843433]
            ]
          ],
          [
            [
              [121.69294130991926, 25.200032146048724],
              [121.69294130991926, 25.200032146048724]
            ]
          ],
          [
            [
              [121.414188300162, 25.189025337203123],
              [121.414188300162, 25.189025337203123]
            ]
          ],
          [
            [
              [121.83952106815391, 25.128753404808055],
              [121.83952106815391, 25.128753404808055]
            ]
          ],
          [
            [
              [121.91419707473345, 25.12633613203929],
              [121.91419707473345, 25.12633613203929]
            ]
          ],
          [
            [
              [121.84486973914233, 25.127923696680334],
              [121.84486973914233, 25.127923696680334]
            ]
          ],
          [
            [
              [121.8619468879018, 25.126328254260475],
              [121.8619468879018, 25.126328254260475]
            ]
          ],
          [
            [
              [121.87430897317476, 25.126182350309367],
              [121.87430897317476, 25.126182350309367]
            ]
          ],
          [
            [
              [121.87498490644725, 25.125437533332523],
              [121.87498490644725, 25.125437533332523]
            ]
          ],
          [
            [
              [121.87855303780985, 25.125014609423616],
              [121.87855303780985, 25.125014609423616]
            ]
          ],
          [
            [
              [121.85987173126395, 25.12513545207985],
              [121.85987173126395, 25.12513545207985]
            ]
          ],
          [
            [
              [121.87550839509842, 25.124714937020915],
              [121.87550839509842, 25.124714937020915]
            ]
          ],
          [
            [
              [121.91921057416707, 25.096585025716095],
              [121.91921057416707, 25.096585025716095]
            ]
          ],
          [
            [
              [121.91891393773886, 25.096053815835706],
              [121.91891393773886, 25.096053815835706]
            ]
          ],
          [
            [
              [121.9185953476023, 25.095422328129196],
              [121.9185953476023, 25.095422328129196]
            ]
          ],
          [
            [
              [121.91705760216827, 25.0920691534866],
              [121.91705760216827, 25.0920691534866]
            ]
          ],
          [
            [
              [121.91608696443872, 25.09149041936702],
              [121.91608696443872, 25.09149041936702]
            ]
          ],
          [
            [
              [121.93034249823107, 25.065112442125205],
              [121.93034249823107, 25.065112442125205]
            ]
          ],
          [
            [
              [121.93147098376282, 25.05643301645129],
              [121.93147098376282, 25.05643301645129]
            ]
          ],
          [
            [
              [121.93215480670082, 25.0560206176614],
              [121.93215480670082, 25.0560206176614]
            ]
          ],
          [
            [
              [121.98324592227728, 25.024786847057367],
              [121.98324592227728, 25.024786847057367]
            ]
          ],
          [
            [
              [121.98436541944498, 25.023230175504985],
              [121.98436541944498, 25.023230175504985]
            ]
          ],
          [
            [
              [121.96344040909395, 25.022836306152307],
              [121.96344040909395, 25.022836306152307]
            ]
          ],
          [
            [
              [122.0050352441706, 25.015533141556595],
              [122.0050352441706, 25.015533141556595]
            ]
          ],
          [
            [
              [122.00704103775247, 25.011309918600073],
              [122.00704103775247, 25.011309918600073]
            ]
          ],
          [
            [
              [122.00621749664337, 25.00942952884271],
              [122.00621749664337, 25.00942952884271]
            ]
          ],
          [
            [
              [121.99266845541405, 24.998173796870066],
              [121.99266845541405, 24.998173796870066]
            ]
          ],
          [
            [
              [121.99145059732957, 24.997847991106166],
              [121.99145059732957, 24.997847991106166]
            ]
          ],
          [
            [
              [121.98605040102001, 24.994218240937517],
              [121.98605040102001, 24.994218240937517]
            ]
          ],
          [
            [
              [121.98555440864827, 24.99320997514627],
              [121.98555440864827, 24.99320997514627]
            ]
          ],
          [
            [
              [121.98427528172921, 24.991128028148655],
              [121.98427528172921, 24.991128028148655]
            ]
          ],
          [
            [
              [121.96715779473176, 24.98170360428009],
              [121.96715779473176, 24.98170360428009]
            ]
          ],
          [
            [
              [121.79344375564224, 24.89973166049105],
              [121.77570110909306, 24.865703996776357],
              [121.77545341249905, 24.865109470746052],
              [121.73104440748978, 24.85535955494072],
              [121.73051608630014, 24.85529903308575],
              [121.68881190044195, 24.81652946582297],
              [121.68849007791842, 24.81624419459081],
              [121.62594381238324, 24.808794604413873],
              [121.62579692490516, 24.808781676551305],
              [121.62564228753712, 24.79521452030119],
              [121.62542825436061, 24.79505966806165],
              [121.59242758827162, 24.787846125048564],
              [121.59219189161493, 24.787804164101658],
              [121.5975687273495, 24.727719888790848],
              [121.59739914957872, 24.72752879239713],
              [121.54355328195422, 24.70573348125364],
              [121.54325365243525, 24.705662329491435],
              [121.53688787711235, 24.688541557539182],
              [121.53678885114695, 24.688424541136648],
              [121.48016094693247, 24.673865447834075],
              [121.47984561768031, 24.673776169849788],
              [121.42335538724109, 24.76180201466814],
              [121.42330173565199, 24.761899222754185],
              [121.44927972924046, 24.78569353649926],
              [121.44952080015618, 24.786035894308966],
              [121.43659603714063, 24.811907968634742],
              [121.43655909076487, 24.812038997862874],
              [121.40340609239475, 24.843239082066074],
              [121.40296711918333, 24.843468161888808],
              [121.37372867032812, 24.833291446059263],
              [121.37356102564951, 24.833273808153017],
              [121.33618233190276, 24.843767461143848],
              [121.33608201614777, 24.843835409328992],
              [121.35788108918553, 24.853157638683463],
              [121.35803187427665, 24.853220476542152],
              [121.34539771035493, 24.8667053740645],
              [121.34504640124126, 24.866940952594003],
              [121.35442301486196, 24.873422161891472],
              [121.3543673636316, 24.87364584677194],
              [121.3211922674097, 24.89995313575677],
              [121.32031930341168, 24.900207817050113],
              [121.31795167910232, 24.91610540884047],
              [121.3175556783441, 24.916347789237534],
              [121.3382488996595, 24.926988834201737],
              [121.33977551603363, 24.928497397503012],
              [121.31673409147277, 24.936898991802995],
              [121.31577677739695, 24.93847666322876],
              [121.3315290775893, 24.9454538834142],
              [121.33160476011294, 24.94563861562157],
              [121.32347675884154, 24.97259469921779],
              [121.32354623954771, 24.972750377088847],
              [121.36904217883982, 24.976815391365704],
              [121.36933311727162, 24.976898073164232],
              [121.40283128327755, 24.99892281246099],
              [121.40294762153161, 24.998994723310986],
              [121.39120133560421, 25.01203318684381],
              [121.3911760965165, 25.01208065145386],
              [121.41206079328566, 25.018761362998454],
              [121.41215482838442, 25.01910417428439],
              [121.390820509327, 25.04172666677836],
              [121.3906620796172, 25.041867029488987],
              [121.4006745291213, 25.051266097172576],
              [121.40068754424563, 25.05136311497609],
              [121.28272535565962, 25.10967316387133],
              [121.28266921121654, 25.109919297795084],
              [121.29660731019732, 25.126112456758],
              [121.29665792989877, 25.12615298213387],
              [121.33287936365042, 25.12445728857098],
              [121.33309982802929, 25.124490739078997],
              [121.3956406310057, 25.15084059968301],
              [121.39572265283805, 25.150903567958924],
              [121.39148532491086, 25.167800962735672],
              [121.39146660342692, 25.167859685494673],
              [121.4118509965597, 25.166992587555235],
              [121.41274232893412, 25.167967118448363],
              [121.40502336808528, 25.183455546756772],
              [121.40501127317712, 25.18354810798272],
              [121.4474393433377, 25.245643802847045],
              [121.4476106245014, 25.245993115289533],
              [121.50903894580483, 25.29055876420318],
              [121.50907077462759, 25.290580609979095],
              [121.5973729689559, 25.291497646950013],
              [121.59796616494722, 25.291468160374087],
              [121.66265240873595, 25.208588093214118],
              [121.66200165405671, 25.207871090853832],
              [121.70192666083102, 25.217018343593285],
              [121.70196071443095, 25.216998754314876],
              [121.68526845667124, 25.190749175333085],
              [121.68525576663293, 25.19071547038232],
              [121.70871221483645, 25.17548279385036],
              [121.70891603302772, 25.175503204400044],
              [121.62698419702818, 25.14003894521875],
              [121.62680686886632, 25.139786915338746],
              [121.6580989893514, 25.091782980521668],
              [121.6581991238427, 25.091678805890986],
              [121.74302278232457, 25.052467896557115],
              [121.74325547013986, 25.05249155887467],
              [121.77550626520905, 25.06972085474194],
              [121.77571073298431, 25.070022252684346],
              [121.74997997281842, 25.10964924560755],
              [121.75002640338222, 25.10974381117797],
              [121.79461858528919, 25.11258763117408],
              [121.79476305976806, 25.112602564996003],
              [121.80251523068317, 25.13438490231246],
              [121.80319179437772, 25.135757952754368],
              [121.82656115236449, 25.135963054576127],
              [121.82665590010146, 25.135996379539172],
              [121.82158901159099, 25.121196799153168],
              [121.82167636117717, 25.12109935815619],
              [121.92376732916114, 25.129709702824456],
              [121.92392594647806, 25.129868960592944],
              [121.91305454576151, 25.088364308523445],
              [121.91298546703348, 25.08836473361047],
              [121.9320213750082, 25.032925245102764],
              [121.93215145168455, 25.032683004933983],
              [122.00543611274543, 25.014793067949395],
              [122.00551119985145, 25.01477450524791],
              [121.96683084947328, 24.98247600610247],
              [121.96678951489245, 24.982456260494395],
              [121.84723242324468, 24.960340007496338],
              [121.84691766584696, 24.960296658836818],
              [121.8390528510522, 24.944831196594382],
              [121.83903392233431, 24.944686858042694],
              [121.85388219919614, 24.925578279227977],
              [121.85362703138354, 24.925162221805994],
              [121.83188707219972, 24.904962053011893],
              [121.83172163896806, 24.90488172458996],
              [121.79344375564224, 24.89973166049105]
            ],
            [
              [121.5273774747525, 24.987002876896725],
              [121.53510360691499, 24.995113540560986],
              [121.53526582786752, 24.995115123786867],
              [121.56058468434495, 24.96535124025292],
              [121.56124211221821, 24.96468310976385],
              [121.60118290447768, 24.960890952305817],
              [121.60145329892157, 24.96093725812771],
              [121.6199450884343, 24.96922316867984],
              [121.62000241683319, 24.969360698431494],
              [121.59968278185865, 24.977817301601913],
              [121.59950806678548, 24.978127199357523],
              [121.59725332778116, 25.014440306989574],
              [121.5973865892381, 25.014658611547997],
              [121.66574660462895, 25.02930079051668],
              [121.66592789309509, 25.02984165553567],
              [121.61929223322721, 25.04323210965076],
              [121.61909826689865, 25.04345860874424],
              [121.62622469599198, 25.0957988059598],
              [121.62622594793704, 25.096044721173907],
              [121.59759540017828, 25.10941655161085],
              [121.59749514786878, 25.109509491909726],
              [121.60569351391825, 25.136677174344427],
              [121.60568145068703, 25.13674501409589],
              [121.57730412199673, 25.166777616455118],
              [121.5770407017002, 25.166990708483887],
              [121.58338714296687, 25.1943120061299],
              [121.58374128576618, 25.19458142632804],
              [121.55952079080492, 25.210180626019202],
              [121.55916455083678, 25.21013448717874],
              [121.45998743349696, 25.12294888101359],
              [121.45878480958676, 25.122957690881346],
              [121.45791041191332, 25.107222134845152],
              [121.46013572568978, 25.104790940289547],
              [121.50535178127251, 25.07664798133735],
              [121.50607386499532, 25.07472028658913],
              [121.48817773350018, 25.01544166403311],
              [121.4885250281122, 25.014695872412037],
              [121.51917142916825, 25.019591397745977],
              [121.51978013244221, 25.01921677977266],
              [121.5273774747525, 24.987002876896725]
            ]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10015001", "COUNTYNAME": "花莲县", "name": "花莲县" },
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [121.50648273279204, 23.507531471268518],
              [121.50648273279204, 23.507531471268518]
            ]
          ],
          [
            [
              [121.5141648115209, 23.493096024828247],
              [121.5141648115209, 23.493096024828247]
            ]
          ],
          [
            [
              [121.50969278406966, 23.492129560474783],
              [121.50969278406966, 23.492129560474783]
            ]
          ],
          [
            [
              [121.51433839050975, 23.481267773486454],
              [121.51433839050975, 23.481267773486454]
            ]
          ],
          [
            [
              [121.37721947259374, 23.28352596655517],
              [121.31746578418604, 23.165367637391714],
              [121.31731942273197, 23.16503618058931],
              [121.32197603225298, 23.117186111576636],
              [121.32188185403805, 23.116987641685142],
              [121.27260510538565, 23.09778341699832],
              [121.27251330741787, 23.097792606032517],
              [121.25781662860959, 23.125906792792687],
              [121.25768116504874, 23.12606955465599],
              [121.21265116155914, 23.144066548283472],
              [121.21194738060586, 23.14421658113226],
              [121.19020312656494, 23.203033647422973],
              [121.18939786530562, 23.203779677834394],
              [121.14862646825455, 23.19869891303976],
              [121.14673781703407, 23.199156779535],
              [121.12956483090689, 23.223135525954824],
              [121.12927647048008, 23.223332175952418],
              [121.07928438377458, 23.23264575892426],
              [121.07907388822801, 23.23274303276664],
              [121.05951196324287, 23.286042141910936],
              [121.05946023880193, 23.286166419907364],
              [121.02974746049311, 23.29748093012065],
              [121.02834838927336, 23.297135686308785],
              [121.04898905989594, 23.324777389725952],
              [121.04879220084102, 23.325305727335913],
              [120.98703579745342, 23.35892415473653],
              [120.98694463554297, 23.359696239928358],
              [121.00254789619439, 23.39396533429209],
              [121.00321246497751, 23.39479613531066],
              [121.02830528499317, 23.403670315126366],
              [121.02839323457488, 23.40386210216915],
              [121.0129046918292, 23.43300317894875],
              [121.01301863246722, 23.43316571380295],
              [121.05892443893387, 23.461347467089098],
              [121.05909379079938, 23.461428665831427],
              [121.03914273897674, 23.473937347589885],
              [121.03912224606455, 23.47420396008855],
              [121.06841481692457, 23.518068790540863],
              [121.06844606359572, 23.51842329997699],
              [121.13504427893955, 23.514904926688466],
              [121.13529315913812, 23.514990496875235],
              [121.15097636673214, 23.526559463870694],
              [121.15111158358943, 23.527044701065012],
              [121.15332138631885, 23.58668618025963],
              [121.1534045088663, 23.586810351551236],
              [121.20600017886844, 23.595761472850615],
              [121.206456462383, 23.595790124243425],
              [121.22361855074281, 23.623059502938972],
              [121.22371233341211, 23.623278434895695],
              [121.23944672032712, 23.723964745733813],
              [121.23945741732506, 23.724115888831026],
              [121.20517832595681, 23.771411509839474],
              [121.2046343088964, 23.772348974716337],
              [121.23037333349308, 23.787927448372734],
              [121.23046588870672, 23.788071786655127],
              [121.23929473575181, 23.83983475598787],
              [121.23936864599578, 23.84032441282146],
              [121.26834534516635, 23.88345005071764],
              [121.26847074281315, 23.883840409437315],
              [121.26111104250838, 23.9024022925749],
              [121.26113212215468, 23.902659519959474],
              [121.27506071550613, 23.90771906127939],
              [121.27606274233618, 23.909694814562474],
              [121.27790767767428, 23.965655328261647],
              [121.277876746113, 23.96583598422776],
              [121.26011515655144, 23.99214798431056],
              [121.26020951709773, 23.992490955211665],
              [121.28312488988884, 24.053997409186938],
              [121.2833234732967, 24.054457579328933],
              [121.32242111774507, 24.08413875000047],
              [121.32316230181189, 24.084920764400874],
              [121.32818347943747, 24.111737699115967],
              [121.32823765316353, 24.11212587175546],
              [121.28141831656964, 24.135579635530124],
              [121.28134588009148, 24.135633954122046],
              [121.28608187316856, 24.176957364801023],
              [121.28616624970815, 24.177316211204236],
              [121.34905402815036, 24.200221273590685],
              [121.34916256637506, 24.2003135745317],
              [121.35210201261074, 24.244175187867228],
              [121.3521607802049, 24.244283401989133],
              [121.38451578316706, 24.255455404130714],
              [121.38463291732309, 24.255516144997085],
              [121.37996949295456, 24.28005331850848],
              [121.38005364032513, 24.280296903265693],
              [121.43338237303203, 24.321893326573402],
              [121.43374245435854, 24.322289602390804],
              [121.45061966169614, 24.365171013612084],
              [121.45099901378815, 24.365395636699976],
              [121.60568800432901, 24.309486867106134],
              [121.60576263895766, 24.309448196697534],
              [121.59568979384726, 24.33147338640127],
              [121.59570696062164, 24.331588536318396],
              [121.61882380053844, 24.345411933634253],
              [121.61954152452263, 24.34547003893695],
              [121.63237780280463, 24.334462940136508],
              [121.63271274669704, 24.334689629923005],
              [121.62041642550146, 24.362955470478386],
              [121.62037611846488, 24.363217479545135],
              [121.63095228461816, 24.370527686765477],
              [121.63112750778961, 24.370517928530234],
              [121.67447723159644, 24.33809156487194],
              [121.67484253783806, 24.337753619189865],
              [121.77291970630789, 24.313814314420423],
              [121.77355335196829, 24.314521968144152],
              [121.74346538335803, 24.260076965854537],
              [121.74307750263482, 24.259638826502442],
              [121.66530577907129, 24.197440146415484],
              [121.6647312816769, 24.196819692804027],
              [121.66309171214634, 24.135135552155607],
              [121.66313094017886, 24.13469297817097],
              [121.61867715652683, 24.08700811113864],
              [121.61819636629811, 24.085777580272904],
              [121.61948004801698, 24.051168917547198],
              [121.61957851150538, 24.05087731049789],
              [121.64719325007367, 24.008717962167864],
              [121.6471917929323, 24.008426723084284],
              [121.60646899904988, 23.957955513284084],
              [121.60624106878267, 23.957276959615704],
              [121.59804402404498, 23.860871802498345],
              [121.59801759514522, 23.86052877856646],
              [121.5026577575395, 23.51976727817491],
              [121.50249843664017, 23.519720385469324],
              [121.51354301878345, 23.483329364978733],
              [121.51369226183539, 23.483313070852184],
              [121.4959406242565, 23.435266464174017],
              [121.49581945388192, 23.43467538371576],
              [121.44725833091137, 23.44376328043757],
              [121.44694231083405, 23.443741610581338],
              [121.42039054756775, 23.420718857162502],
              [121.42024008001691, 23.42061993109527],
              [121.40002893326452, 23.386139237576053],
              [121.40001621186434, 23.38536505277769],
              [121.42234328455403, 23.355724701611745],
              [121.42220202341291, 23.355228423880245],
              [121.37721947259374, 23.28352596655517]
            ]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10012001", "COUNTYNAME": "高雄市", "name": "高雄市" },
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [120.45430967655587, 22.77177338953383],
            [120.4335267704772, 22.623620429618647],
            [120.43348267823959, 22.623252149376135],
            [120.444902472395, 22.57321572284377],
            [120.44437978977966, 22.569894701366096],
            [120.42395039217894, 22.479455200611905],
            [120.4240574512121, 22.47702838409176],
            [120.39674564515546, 22.477552246748587],
            [120.39672341048522, 22.47754505619104],
            [120.29868401264206, 22.54739137762406],
            [120.29856655255298, 22.547426997570522],
            [120.31695231101065, 22.551059989041647],
            [120.31685405947881, 22.55135977321578],
            [120.30079932104464, 22.55100629222898],
            [120.30066958457674, 22.551035168475437],
            [120.25558758203614, 22.618378498965107],
            [120.25515979069621, 22.61892432971076],
            [120.2503494480651, 22.656500143029934],
            [120.25031777546245, 22.656648999409153],
            [120.26433675712347, 22.6772344900634],
            [120.2643338665887, 22.6777763203569],
            [120.25362329769976, 22.692691780666873],
            [120.25348464257507, 22.69439798776943],
            [120.26829893658449, 22.67994400902661],
            [120.27008211312864, 22.68003321516532],
            [120.27472053481914, 22.706614706470937],
            [120.27471471693985, 22.706795291255396],
            [120.25653421812993, 22.695748559701947],
            [120.25643372307118, 22.695838614975912],
            [120.21443646433207, 22.804433943038756],
            [120.21401068679525, 22.805344127726343],
            [120.19332250108839, 22.807447111570546],
            [120.19016920290062, 22.81356528343802],
            [120.19798473237913, 22.805463335732558],
            [120.20352777245114, 22.806385009819863],
            [120.20882072461454, 22.818146847284808],
            [120.20874856965338, 22.81909697713638],
            [120.1900670976044, 22.84177670591406],
            [120.1897951584132, 22.841734686226403],
            [120.17502005074815, 22.911535032698943],
            [120.17503992092708, 22.911751354531273],
            [120.22878972534794, 22.916977132117076],
            [120.22952423928002, 22.916905989554795],
            [120.25333507536686, 22.894531646506245],
            [120.25399308971227, 22.894311009946755],
            [120.28359803651487, 22.904698185001536],
            [120.28445548976245, 22.904742775450547],
            [120.35162609171157, 22.88750052808924],
            [120.35179385866859, 22.88748315123996],
            [120.3814911712098, 22.921070222402257],
            [120.38158988333205, 22.921138335247626],
            [120.4153765993797, 22.915677645624953],
            [120.41606523751945, 22.916020980864996],
            [120.46014158127917, 23.002882653375554],
            [120.46033771403366, 23.003386787637837],
            [120.47979340066972, 23.0026566468199],
            [120.47989100581343, 23.002681801185233],
            [120.55441669494846, 23.068786886524094],
            [120.55455462285924, 23.06890685682786],
            [120.64041163716426, 23.182746783218153],
            [120.64109491429065, 23.182949268923476],
            [120.65614804717423, 23.217618522534348],
            [120.65625279047502, 23.217846768509983],
            [120.64349617927199, 23.295819467079806],
            [120.64365710465052, 23.29601632258096],
            [120.6987655842214, 23.284499126692204],
            [120.69960068559713, 23.28445773439478],
            [120.75769862362924, 23.343912180856645],
            [120.75793547057245, 23.344179058007914],
            [120.78311088044671, 23.342168926269952],
            [120.78333424726303, 23.342214531445943],
            [120.80347580018831, 23.37006488565281],
            [120.80387884530498, 23.370406392654452],
            [120.82521211132912, 23.371565241578672],
            [120.82538594104014, 23.37164897481829],
            [120.84929092465873, 23.41979087160885],
            [120.84953300249437, 23.42013426287936],
            [120.90042286921091, 23.45403479088598],
            [120.90067960299957, 23.45420433409176],
            [120.96547474817628, 23.470742300761785],
            [120.96669040138035, 23.47167944784381],
            [121.00770055818734, 23.462688455779247],
            [121.0081240680715, 23.46236560444601],
            [121.02803977007258, 23.40460716345228],
            [121.02839323457488, 23.40386210216915],
            [121.00342595779125, 23.395012803408836],
            [121.00321246497751, 23.39479613531066],
            [120.98694463554297, 23.359696239928358],
            [120.98703579745342, 23.35892415473653],
            [121.04898905989594, 23.324777389725952],
            [121.04902860194257, 23.324278540119987],
            [121.02440734674246, 23.294129226685154],
            [121.02419008200059, 23.293898985152076],
            [120.9725859231649, 23.282147512120186],
            [120.97213001895706, 23.2819307018915],
            [120.91607894871139, 23.238103439160454],
            [120.91579957663471, 23.238003954680874],
            [120.91126235431197, 23.182831475186685],
            [120.91110106677415, 23.182300931409973],
            [120.87654207081233, 23.15147594342771],
            [120.87639340331197, 23.15134723187201],
            [120.88917840783598, 23.11099202881135],
            [120.88939168965315, 23.11005983231384],
            [120.87003238592315, 23.060900587692725],
            [120.8691554498151, 23.05969421805902],
            [120.88055442226594, 23.03835287536617],
            [120.88009194301891, 23.036020370261973],
            [120.86253976652091, 23.031646866556716],
            [120.86186946543664, 23.031063821833445],
            [120.86076964560596, 23.008308439393893],
            [120.86060430048956, 23.00797418478985],
            [120.8208429463805, 22.962176574738393],
            [120.82080218766029, 22.96189196978316],
            [120.82849435725792, 22.90467422645258],
            [120.82860449656131, 22.90416398670824],
            [120.86422913752257, 22.8731348276399],
            [120.86488989500346, 22.87245569127834],
            [120.86475002555437, 22.843659002136953],
            [120.86465147333573, 22.843098975679506],
            [120.82585775656275, 22.866407563685247],
            [120.82529664302955, 22.866438565617848],
            [120.77929214011976, 22.835199425399058],
            [120.77880568459096, 22.83518954813504],
            [120.7253308648916, 22.880627921022292],
            [120.72504176830012, 22.880803549144336],
            [120.67268171105746, 22.8563989270093],
            [120.67222800463361, 22.856368733549974],
            [120.6450485958991, 22.885151436070675],
            [120.64493085869947, 22.885155778887174],
            [120.60586012972784, 22.873229258626527],
            [120.60535794828904, 22.872995409038495],
            [120.5540825189619, 22.828760170305518],
            [120.55322681475815, 22.828382952094586],
            [120.47634722958587, 22.838189610505374],
            [120.47619325118026, 22.838166437202823],
            [120.45430967655587, 22.77177338953383]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10007001", "COUNTYNAME": "彰化县", "name": "彰化县" },
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [120.26482340772516, 23.87243127563179],
              [120.26482340772516, 23.87243127563179]
            ]
          ],
          [
            [
              [120.26929675129759, 23.87132656516917],
              [120.26929675129759, 23.87132656516917]
            ]
          ],
          [
            [
              [120.27083448158179, 23.86914015820578],
              [120.27083448158179, 23.86914015820578]
            ]
          ],
          [
            [
              [120.26581308189576, 23.867842793910818],
              [120.26581308189576, 23.867842793910818]
            ]
          ],
          [
            [
              [120.26637771747087, 23.867217448025304],
              [120.26637771747087, 23.867217448025304]
            ]
          ],
          [
            [
              [120.26485937703909, 23.866254949499975],
              [120.26485937703909, 23.866254949499975]
            ]
          ],
          [
            [
              [120.62829678760964, 23.93148291702954],
              [120.63421397071586, 23.893646993678942],
              [120.63437770911933, 23.893428307247998],
              [120.61554828812109, 23.840540925688735],
              [120.61554880089606, 23.840367016335783],
              [120.65052374882953, 23.812824428094352],
              [120.65089462531998, 23.81250245674939],
              [120.67505729656156, 23.819813520398437],
              [120.67633749197928, 23.81922474976333],
              [120.68376581048899, 23.803698276398112],
              [120.68389427448909, 23.803355545904232],
              [120.64303240236205, 23.785956346533972],
              [120.64252033489049, 23.78572941884599],
              [120.50975273152513, 23.800238180991112],
              [120.50883019569582, 23.800424868488765],
              [120.43352671155556, 23.830075168538777],
              [120.43314965453851, 23.83015730517283],
              [120.30865306975902, 23.820322482424217],
              [120.30814032834708, 23.82029746489297],
              [120.24771349861875, 23.83853288286164],
              [120.24223815461872, 23.842329981792222],
              [120.28657868960677, 23.874378300365716],
              [120.2870934581654, 23.87468982877322],
              [120.31887457333328, 23.935082337730837],
              [120.31909516292626, 23.93583953101871],
              [120.30425660636357, 23.94012512685613],
              [120.3044049492348, 23.94062918551609],
              [120.3664142584804, 24.03209702630145],
              [120.36377525793986, 24.035146974380343],
              [120.4065400886656, 24.055316355464235],
              [120.40669726335574, 24.055499805824077],
              [120.38527818591697, 24.058139769623455],
              [120.37799255365981, 24.057992873621686],
              [120.37764376684017, 24.073652594049996],
              [120.37752590592757, 24.076518773555236],
              [120.43339769172864, 24.089146775286135],
              [120.43515181378147, 24.089821794686365],
              [120.43648584121102, 24.120927002825578],
              [120.4365117575599, 24.1214327123515],
              [120.37956415654601, 24.09430340942668],
              [120.37990451581639, 24.09502684840608],
              [120.4388677636471, 24.15838567638431],
              [120.4391666163272, 24.15864645215115],
              [120.46376742253901, 24.16131866181553],
              [120.46383329825245, 24.161269594331657],
              [120.48536805473583, 24.195879432173346],
              [120.48590467268795, 24.197417093735208],
              [120.5079541700765, 24.18729452484223],
              [120.50834356773328, 24.186774312573704],
              [120.54524635341605, 24.116682270582086],
              [120.54542204650245, 24.116466082420057],
              [120.61241514167978, 24.1025743951042],
              [120.61251115074064, 24.102540697328205],
              [120.62457941888792, 24.030835230562584],
              [120.62513081920378, 24.03018426908761],
              [120.67625177146833, 24.01559489974392],
              [120.67866422186995, 24.014030719026568],
              [120.63831073219416, 24.007422952056455],
              [120.6380393257197, 24.007438112997562],
              [120.65016763169815, 23.984392011193222],
              [120.65019494948214, 23.983800678432047],
              [120.64690005124268, 23.96350472474069],
              [120.64686285160676, 23.96340757198545],
              [120.62695144651711, 23.956554728060876],
              [120.6268362276461, 23.9564190146073],
              [120.62829678760964, 23.93148291702954]
            ]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10010001", "COUNTYNAME": "嘉义县", "name": "嘉义县" },
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [120.13537463592019, 23.43690010505967],
              [120.13537463592019, 23.43690010505967]
            ]
          ],
          [
            [
              [120.13578946455827, 23.42545831559659],
              [120.13578946455827, 23.42545831559659]
            ]
          ],
          [
            [
              [120.14173164502466, 23.41180295220321],
              [120.14173164502466, 23.41180295220321]
            ]
          ],
          [
            [
              [120.1489279193124, 23.478703353891046],
              [120.1489279193124, 23.478703353891046]
            ]
          ],
          [
            [
              [120.14834523168199, 23.478360680604272],
              [120.14834523168199, 23.478360680604272]
            ]
          ],
          [
            [
              [120.14046206278469, 23.477198861520392],
              [120.14046206278469, 23.477198861520392]
            ]
          ],
          [
            [
              [120.14137866809476, 23.476529057062702],
              [120.14137866809476, 23.476529057062702]
            ]
          ],
          [
            [
              [120.14281146177848, 23.475392579053743],
              [120.14281146177848, 23.475392579053743]
            ]
          ],
          [
            [
              [120.6519683977136, 23.29115642805552],
              [120.6383094000197, 23.26950697533167],
              [120.63826031882864, 23.26930151312841],
              [120.65349940997102, 23.224541259455265],
              [120.65311544334723, 23.224316911170888],
              [120.61046349956024, 23.222814415011758],
              [120.60983067356005, 23.222627805191813],
              [120.59264269036125, 23.239851751933333],
              [120.59248835580962, 23.239846836600616],
              [120.5783278288124, 23.214839807873243],
              [120.57824132019417, 23.214778702494204],
              [120.52673714984013, 23.230927828632606],
              [120.52636458332226, 23.23106676570106],
              [120.52256542000136, 23.311623718170303],
              [120.52252506210996, 23.31175903866353],
              [120.53997282802362, 23.327832303620013],
              [120.53997653608121, 23.327908971535813],
              [120.50546360950321, 23.344625240523246],
              [120.50507793953156, 23.344822684435105],
              [120.50508084078665, 23.36863066634733],
              [120.50484920451753, 23.368898578405084],
              [120.48410217581319, 23.36948913363441],
              [120.48395301052834, 23.36957447244694],
              [120.49498286198613, 23.394186205225335],
              [120.49492414674783, 23.394350732552397],
              [120.47944734504529, 23.387599753819575],
              [120.47937628076666, 23.387595002212098],
              [120.44003457180435, 23.41369834617638],
              [120.43987575097891, 23.413727124246392],
              [120.31501254528597, 23.388511962570583],
              [120.31484600959543, 23.388497778449256],
              [120.2126569208406, 23.29187132477942],
              [120.21235384962321, 23.291673404788433],
              [120.17894779456367, 23.291620571032055],
              [120.17857162719923, 23.29179684902677],
              [120.11735841106592, 23.342430458284273],
              [120.11734588320601, 23.34247187870094],
              [120.13800609152739, 23.373415242824283],
              [120.13840325424502, 23.37382376297842],
              [120.15647424611728, 23.375438858935322],
              [120.1565631138765, 23.375475456660617],
              [120.13936755467688, 23.384499854330894],
              [120.13942092855574, 23.38461301798522],
              [120.15756704804956, 23.379708846648473],
              [120.15811507059931, 23.37966664937604],
              [120.1661822615518, 23.393101029825207],
              [120.16625045433993, 23.393243709467963],
              [120.1496593793196, 23.405250190727465],
              [120.14940766611983, 23.406126975132974],
              [120.1524601445777, 23.45436887524173],
              [120.15224277051651, 23.454835099111204],
              [120.13325084557556, 23.451479989329165],
              [120.13325028638616, 23.451565676249803],
              [120.15522625397112, 23.490992906640916],
              [120.15522580804684, 23.491062882836378],
              [120.16980033454662, 23.490461836984],
              [120.16992363533619, 23.490457888740842],
              [120.12541738403246, 23.48835010478041],
              [120.12466842326722, 23.48871150247729],
              [120.12152456149221, 23.519480363561502],
              [120.12268442104451, 23.520048740858112],
              [120.2384023596686, 23.507418323773628],
              [120.23909386160784, 23.5076835711297],
              [120.24322828639917, 23.543491482738986],
              [120.24355058548021, 23.543757156162748],
              [120.27101116495339, 23.530461612359893],
              [120.27196179245522, 23.53075952492428],
              [120.2897188514665, 23.56198010190088],
              [120.29020975461671, 23.562424803901923],
              [120.40405596589957, 23.63401825262887],
              [120.40460620678193, 23.63418744160029],
              [120.42501370403855, 23.618033677838756],
              [120.42522147447954, 23.618009751167957],
              [120.50358971571166, 23.63529603648532],
              [120.50376039290373, 23.6352762656049],
              [120.53599727219992, 23.59536773124712],
              [120.53689395278423, 23.59474968651307],
              [120.58101159970016, 23.582220062324982],
              [120.5813035861765, 23.582112481530025],
              [120.64803162089822, 23.593302814794043],
              [120.64855216107743, 23.59341911611437],
              [120.64342393154361, 23.57596962154064],
              [120.64346379819524, 23.57560633859743],
              [120.67584528985884, 23.57060134542858],
              [120.6762147475398, 23.570505052165654],
              [120.73548675568405, 23.570424982542292],
              [120.73615378063558, 23.570448781492516],
              [120.72485925366448, 23.603627362720864],
              [120.72483744809065, 23.603805774362442],
              [120.75254012127021, 23.614827149281187],
              [120.75343485288478, 23.61485129251458],
              [120.82510853115942, 23.586676923436535],
              [120.82550693640064, 23.586395164806973],
              [120.80832231068612, 23.53988478947421],
              [120.80831011651105, 23.539322724104977],
              [120.83276117685106, 23.47458993650315],
              [120.83302038354402, 23.47440058081935],
              [120.95729612466258, 23.469634167056455],
              [120.95758464915022, 23.469496445005205],
              [120.85022062278637, 23.420663120119684],
              [120.84987257710988, 23.420425733356804],
              [120.82543555411425, 23.37169652946425],
              [120.82538594104014, 23.37164897481829],
              [120.80423603531221, 23.370628009491053],
              [120.80387884530498, 23.370406392654452],
              [120.78345004964639, 23.34226887341821],
              [120.78333424726303, 23.342214531445943],
              [120.75820853079672, 23.344278822052157],
              [120.75793547057245, 23.344179058007914],
              [120.70116297072889, 23.28551733804402],
              [120.69960068559713, 23.28445773439478],
              [120.6519683977136, 23.29115642805552]
            ],
            [
              [120.39414145043601, 23.46252766245565],
              [120.42615024808686, 23.46072563329955],
              [120.42930183817928, 23.461035199787425],
              [120.43952624521339, 23.43958096449851],
              [120.43969330927787, 23.439563504368927],
              [120.46852932213955, 23.461508420936603],
              [120.4686881720279, 23.461599261462542],
              [120.4948167632867, 23.452791556352395],
              [120.49523235445339, 23.452892231050484],
              [120.50933660596809, 23.474004390968066],
              [120.50936058852785, 23.474302464295626],
              [120.48337108334033, 23.505090866533727],
              [120.48316606308609, 23.505367874038154],
              [120.4656897477053, 23.498705439860718],
              [120.46546288238979, 23.498740781260427],
              [120.44173442757331, 23.518038224037916],
              [120.4406007497266, 23.518232820855047],
              [120.38983669371666, 23.49891852752021],
              [120.38944255251171, 23.498731863276497],
              [120.39414145043601, 23.46252766245565]
            ]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "09020001", "COUNTYNAME": "金门县", "name": "金门县" },
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [118.3648311214179, 24.428418953225275],
              [118.32776673731406, 24.387137323370123],
              [118.32771676397569, 24.387106190780578],
              [118.29595522958793, 24.395898278508795],
              [118.29592609897679, 24.39590402121359],
              [118.27816123467326, 24.413691966684006],
              [118.27818344946213, 24.413745886005252],
              [118.31079788816632, 24.428504929349167],
              [118.31079005581583, 24.42857803237905],
              [118.28726797995677, 24.470253597614256],
              [118.28729847999348, 24.470356047675757],
              [118.3112086024529, 24.490312218284384],
              [118.31123766503579, 24.49031395697936],
              [118.37349157819627, 24.46133278587268],
              [118.37356585059018, 24.461357917006026],
              [118.40805236622909, 24.529536312814493],
              [118.40816635544275, 24.529564941111193],
              [118.44892258746204, 24.507880202416043],
              [118.44895158577516, 24.5078531527249],
              [118.4733965512073, 24.4450351941157],
              [118.47340300835519, 24.445008444429078],
              [118.43034651380668, 24.407032380043685],
              [118.43026425775108, 24.40701131642551],
              [118.42833849959793, 24.4249230064863],
              [118.42823366682332, 24.425036407127273],
              [118.40333774136829, 24.434237739717293],
              [118.40322673957908, 24.434276881890987],
              [118.3648311214179, 24.428418953225275]
            ]
          ],
          [
            [
              [118.26339600369043, 24.42533843681105],
              [118.22573358278616, 24.4047461949994],
              [118.2256739425247, 24.404723129020592],
              [118.21135837834935, 24.41267663509382],
              [118.21134755512834, 24.412721444659],
              [118.24605406320892, 24.453199515873514],
              [118.24621737645417, 24.453260879520464],
              [118.26704513670695, 24.4433620798556],
              [118.26708601014673, 24.443314678573785],
              [118.26339600369043, 24.42533843681105]
            ]
          ],
          [
            [
              [118.43552207957454, 24.523287317765142],
              [118.43552207957454, 24.523287317765142]
            ]
          ],
          [
            [
              [118.22895673665518, 24.404511668661193],
              [118.22895673665518, 24.404511668661193]
            ]
          ],
          [
            [
              [118.41142327484205, 24.529214586568635],
              [118.41142327484205, 24.529214586568635]
            ]
          ],
          [
            [
              [118.45701766807419, 24.415121956289894],
              [118.45701766807419, 24.415121956289894]
            ]
          ],
          [
            [
              [118.47558771763353, 24.447879885549497],
              [118.47558771763353, 24.447879885549497]
            ]
          ],
          [
            [
              [118.34678332459893, 24.409579346050933],
              [118.34678332459893, 24.409579346050933]
            ]
          ],
          [
            [
              [118.45803866461813, 24.41665266872469],
              [118.45803866461813, 24.41665266872469]
            ]
          ],
          [
            [
              [118.3377123077349, 24.395471237458903],
              [118.3377123077349, 24.395471237458903]
            ]
          ],
          [
            [
              [118.47804379661842, 24.448614696807315],
              [118.47804379661842, 24.448614696807315]
            ]
          ],
          [
            [
              [118.24166310179359, 24.460030768736793],
              [118.24166310179359, 24.460030768736793]
            ]
          ],
          [
            [
              [118.33852898663417, 24.38998305814465],
              [118.33852898663417, 24.38998305814465]
            ]
          ],
          [
            [
              [118.46727482872654, 24.46258359514346],
              [118.46727482872654, 24.46258359514346]
            ]
          ],
          [
            [
              [118.23157100523436, 24.45774152043684],
              [118.23157100523436, 24.45774152043684]
            ]
          ],
          [
            [
              [118.23159913416197, 24.468614029926577],
              [118.23159913416197, 24.468614029926577]
            ]
          ],
          [
            [
              [118.33622760819046, 24.386595334716105],
              [118.33622760819046, 24.386595334716105]
            ]
          ]
        ]
      }
    },
    {
      "properties": { "COUNTYSN": "10018001", "COUNTYNAME": "新竹市", "name": "新竹市" },
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [120.91090061030832, 24.827204872753327],
            [120.91350748947282, 24.851656458293544],
            [120.91323627190252, 24.851920314063996],
            [120.92477961212273, 24.84825650718079],
            [120.92542265954211, 24.8500039733091],
            [120.91296021743752, 24.85378918157757],
            [120.91296002308017, 24.854066917806076],
            [120.98301576022268, 24.83096251272202],
            [120.9837697168344, 24.83063077783169],
            [121.02552671678036, 24.79913785476941],
            [121.02571371626333, 24.799099451097156],
            [121.03352213091625, 24.764046815183413],
            [121.03355249036268, 24.763760057915505],
            [121.02086703690337, 24.75656849649709],
            [121.02062216982951, 24.756606902274566],
            [120.98818619135142, 24.7774297253072],
            [120.98581749130342, 24.776932943833557],
            [120.94434755267343, 24.744446310643585],
            [120.94416100341994, 24.74428137740302],
            [120.93606477269815, 24.713845758708523],
            [120.93543452074101, 24.712604039038222],
            [120.91376230832081, 24.717281211021756],
            [120.91365553845026, 24.717355555266206],
            [120.90815091977983, 24.740883964852586],
            [120.90784105597137, 24.741071128983716],
            [120.88178559125684, 24.733576343306034],
            [120.88103916782731, 24.733273273704423],
            [120.91090061030832, 24.827204872753327]
          ]
        ]
      }
    }
  ]
})
}))
